export const fr = {


  "translation": {
    "vacationContent": {"title":"Titre de l’annonce","description":"Description"},
"desktopHome": {"mapTitle":"Découvrez des biens partout en Tunisie","mapUnavailable":"La carte est momentanément indisponible.","verified":"Annonces vérifiées","verifiedText":"Des annonces contrôlées pour plus de confiance.","everywhere":"Partout en Tunisie","everywhereText":"Des biens dans tous les gouvernorats.","simple":"Simple et rapide","simpleText":"Trouvez votre bien en quelques clics.","support":"Une équipe à votre écoute","supportText":"Un accompagnement personnalisé à chaque étape."},
"vacationPublication": {"optionalPrice":"Prix par nuit (facultatif)","invalidPrice":"Renseignez un prix positif valide ou laissez ce champ vide.","noPrice":"Prix non renseigné","contactForPrice":"Contactez l’annonceur pour connaître le tarif avant de réserver.","imageLimit":"Vous pouvez ajouter jusqu’à {{count}} images maximum.","imageCount":"{{count}} / {{max}} images"},
    "mobileFinal": {"reset":"Réinitialiser","apply":"Afficher les résultats","searchPlaceholder":"Ville, quartier ou mot-clé","aiIntro":"Décrivez ce que vous cherchez, je m’occupe du reste","aiExample":"Ex. : S+2 à Sousse, 250 000 DT","longStay":"Vente ou location longue durée","publishVacation":"Publier une location de vacances","shortStay":"Location journalière ou vacances"},
    "phoneNav": {"navigation":"Navigation principale","favorites":"Favoris","publish":"Annoncer","profile":"Profil","menu":"Menu","sale":"À vendre","rent":"Location","vacation":"Vacances","requests":"Recherches"},
    "homeDestinations": { "sidiBouSaid": "Sidi Bou Saïd" },
    "voice": {"start":"Dicter","stop":"Arrêter la dictée","listening":"J'écoute…","denied":"Micro non autorisé. Vous pouvez écrire au clavier.","noSpeech":"Je n'ai rien entendu. Réessayez.","error":"La dictée n'a pas fonctionné. Vous pouvez écrire au clavier."},
    "propertyRequest": {"notify":{"proposal":"Nouvelle proposition reçue pour l'une de vos recherches."},"nav":{"public":"Recherches immobilières","mine":"Mes recherches","new":"Nouveau"},"home":{"title":"Vous ne trouvez pas le bien idéal ?","lead":"Décrivez ce que vous cherchez : les annonceurs pourront vous proposer leurs biens.","start":"Je recherche un bien","browse":"Voir les recherches","resume":"Reprendre ma recherche"},"new":{"title":"Je recherche un bien","subtitle":"Décrivez ce que vous cherchez et Lina Immo vous aide à trouver les annonces correspondantes.","draftRestored":"Votre recherche en cours a été restaurée.","restart":"Recommencer","continue":"Continuer"},"text":{"label":"Décrivez votre recherche","placeholder":"Je cherche un terrain de 200 à 300 m² à Sahloul, budget maximum 250 000 DT.","notice":"Le texte libre est visible des annonceurs mais certains critères mentionnés uniquement dans le texte peuvent ne pas être utilisés dans le classement.","noContact":"N'écrivez ni e-mail ni téléphone dans ce texte : ils seraient masqués.","count":"{{count}} / {{max}}"},"criteria":{"title":"Critères","required":"obligatoire","transaction":"Transaction","categories":"Type de bien","city":"Ville","chooseCity":"Choisir une ville","delegations":"Délégations","delegationsHint":"Facultatif, jusqu'à {{max}}. Sans délégation : toute la ville.","addDelegation":"Ajouter une délégation","removeDelegation":"Retirer {{name}}","chooseCityFirst":"Choisissez d'abord une ville.","budgetMin":"Budget min ({{unit}})","budgetMax":"Budget max ({{unit}})","surfaceMin":"Surface min (m²)","surfaceMax":"Surface max (m²)","min":"Min","max":"Max","more":"Chambres et équipements","bedroomsMin":"Chambres (minimum)","attributes":"Équipements","landNote":"Un terrain n'a ni chambres ni équipements.","chooseTypeFirst":"Choisissez d'abord un type de bien."},"transaction":{"sale":"Acheter","rent":"Louer","vacation":"Location vacances"},"transactionShort":{"sale":"Achat","rent":"Location","vacation":"Vacances"},"attribute":{"parking":"Parking","furnished":"Meublé","kitchen":"Cuisine","ac":"Climatisation","pool":"Piscine","garden":"Jardin","barbecue":"Barbecue","beachAccess":"Accès plage","workspace":"Espace de travail","washer":"Lave-linge","wifi":"Wi-Fi","tv":"Télévision","elevator":"Ascenseur","balcony":"Balcon ou terrasse","seaView":"Vue mer"},"budgetUnit":{"sale":"DT","rent":"DT / mois","vacation":"DT / nuit"},"preview":{"title":"Vérifiez votre recherche","subtitle":"Rien n'est publié à cette étape. Corrigez ce qui ne convient pas.","text":"Votre texte","summary":"Vous recherchez :","edit":"Modifier","publish":"Publier ma recherche","publishing":"Publication…","signInTitle":"Connexion requise pour publier","signInText":"Vos critères restent enregistrés dans cet onglet pendant la connexion. Revenez ensuite par « Reprendre ma recherche ».","signIn":"Se connecter","signUp":"Créer un compte","lifetime":"Votre recherche reste publiée 30 jours. Vous pourrez la modifier ou la clôturer depuis « Mes recherches »."},"summary":{"transaction":"Transaction","categories":"Type de bien","location":"Localisation","wholeCity":"{{city}} (toute la ville)","budget":"Budget","surface":"Surface","bedrooms":"Chambres","attributes":"Équipements","text":"Texte libre","contact":"Contact","none":"Non précisé","min":"min {{value}}","max":"max {{value}}","between":"{{min}} – {{max}}","bedroomsValue":"{{count}} minimum"},"contact":{"title":"Comment vous contacter ?","email":"E-mail","phone":"Téléphone","both":"Les deux","prefilled":"Prérempli depuis votre compte","privacy":"Votre e-mail et votre téléphone ne sont jamais affichés publiquement. Ils servent uniquement à vous prévenir et à vous mettre en relation."},"done":{"title":"Votre recherche est publiée","text":"Elle reste visible jusqu'au {{date}}.","mine":"Voir mes recherches","view":"Voir la recherche publiée","another":"Nouvelle recherche"},"mine":{"title":"Mes recherches","new":"Nouvelle","tabActive":"Actives","tabClosed":"Clôturées","tabExpired":"Expirées","empty":"Aucune recherche dans cette catégorie.","published":"Publiée le {{date}}","expires":"expire le {{date}}","expiredOn":"expirée le {{date}}","closedOn":"clôturée le {{date}}","proposals":"{{count}} proposition(s) reçue(s)","edit":"Modifier","close":"Clôturer","delete":"Supprimer","closeQuestion":"Clôturer cette recherche ?","closeNote":"Elle ne sera plus visible des annonceurs.","deleteQuestion":"Supprimer définitivement cette recherche ?","deleteNote":"Elle disparaîtra de vos recherches et de la liste publique.","cancel":"Annuler","closed":"Recherche clôturée.","deleted":"Recherche supprimée.","loadMore":"Afficher plus","retry":"Réessayer","loading":"Chargement…"},"edit":{"title":"Modifier ma recherche","save":"Enregistrer","saving":"Enregistrement…","saved":"Recherche mise à jour.","expiryNote":"La modification ne prolonge pas la publication : expiration le {{date}}.","notEditable":"Cette recherche est introuvable ou n'est plus active.","back":"Retour à mes recherches"},"list":{"title":"Recherches immobilières","subtitle":"Des personnes cherchent un bien. Proposez le vôtre s'il correspond.","start":"Je recherche un bien","allTransactions":"Toutes les transactions","allTypes":"Tous les types","allCities":"Toutes les villes","empty":"Aucune recherche ne correspond.","view":"Voir la recherche","previous":"Précédent","next":"Suivant","page":"Page {{page}} sur {{pages}}"},"detail":{"published":"Publiée le {{date}}","expires":"expire le {{date}}","description":"Description","privacy":"Les coordonnées de la personne qui cherche ne sont pas affichées.","back":"Toutes les recherches"},"status":{"Active":"Active","Closed":"Clôturée","Expired":"Expirée"},"cardTitle":"{{type}} à {{place}}","errors":{"transactionRequired":"Choisissez acheter, louer ou location vacances.","categoryRequired":"Choisissez au moins un type de bien.","categoryInvalid":"Ce type n'est pas disponible pour cette transaction.","cityRequired":"Choisissez une ville.","cityInvalid":"Ville inconnue.","tooManyDelegations":"5 délégations au maximum.","delegationInvalid":"Délégation inconnue pour cette ville.","invalidNumber":"Nombre invalide.","minAboveMax":"Le minimum dépasse le maximum.","invalidBedrooms":"Nombre de chambres invalide (0 à 30).","textTooLong":"1000 caractères au maximum.","preferenceRequired":"Choisissez un mode de contact.","emailRequired":"L'e-mail est obligatoire pour ce mode de contact.","emailInvalid":"E-mail invalide.","phoneRequired":"Le téléphone est obligatoire pour ce mode de contact.","phoneInvalid":"Téléphone invalide (8 à 15 chiffres).","fixBelow":"Corrigez les champs signalés.","invalid":"Certaines informations sont invalides. Vérifiez le formulaire.","signIn":"Connectez-vous pour continuer.","forbidden":"Cette recherche ne vous appartient pas.","notFound":"Recherche introuvable ou supprimée.","tooManyActive":"Vous avez déjà 10 recherches actives. Clôturez-en une avant d'en publier une nouvelle.","notActive":"Cette recherche n'est plus active : elle ne peut plus être modifiée.","tooManyCreated":"Vous avez publié 5 recherches au cours de la dernière heure. Réessayez un peu plus tard.","tooManyRequests":"Trop de demandes. Réessayez dans un instant.","tooManyRequestsWait_one":"Trop de demandes. Réessayez dans une minute.","tooManyRequestsWait_two":"Trop de demandes. Réessayez dans 2 minutes.","tooManyRequestsWait_few":"Trop de demandes. Réessayez dans {{count}} minutes.","tooManyRequestsWait_many":"Trop de demandes. Réessayez dans {{count}} minutes.","tooManyRequestsWait_other":"Trop de demandes. Réessayez dans {{count}} minutes.","server":"Le service est momentanément indisponible. Réessayez plus tard.","alreadyProposed":"Vous avez déjà proposé ce bien.","requestClosed":"Cette recherche n'accepte plus de propositions.","ownRequest":"Vous ne pouvez pas proposer un bien à votre propre recherche.","listingNotOwned":"Vous ne pouvez proposer que vos propres annonces.","listingNotFound":"Cette annonce est introuvable ou a été supprimée.","listingMismatch":"Cette annonce ne correspond pas au type de recherche.","tooManyProposals":"Trop de propositions envoyées récemment. Réessayez plus tard.","messageInvalid":"Message trop long (500 caractères au maximum).","chooseListing":"Choisissez une de vos annonces."},"analysis":{"button":"Analyser avec Lina AI","analyzing":"Analyse en cours…","needText":"Écrivez d'abord votre recherche.","done":"Critères détectés : vérifiez-les et complétez si besoin.","nothing":"Aucun critère n'a été détecté dans votre texte. Complétez les critères ci-dessous.","unavailable":"Lina AI n'est pas disponible pour le moment : seuls les critères écrits explicitement ont été détectés.","detected":"Critères détectés","remove":"Retirer : {{label}}","manual":"Saisi par vous","ai":"Lina AI","auto":"Analyse automatique du texte","unscored":"Mentionné dans votre texte, non pris en compte dans le classement."},"matches":{"see":"Voir les annonces correspondantes","title":"Annonces correspondantes","loading":"Recherche dans les annonces…","strong":"Très bons matchs","close":"Bons matchs","alternative":"Alternatives","badgeStrong":"Très bon match","badgeClose":"Bon match","badgeAlternative":"Alternative","none":"Nous n’avons pas trouvé de bien correspondant suffisamment à votre recherche.","publishQuestion":"Voulez-vous publier votre recherche ?","noneFit":"Aucune de ces annonces ne vous convient ?","publish":"Publier ma recherche","edit":"Modifier ma recherche","view":"Voir l'annonce","why":"Pourquoi cette annonce","noPhoto":"Photo non disponible","bedrooms":"{{count}} chambre(s)"},"why":{"matches":"Correspond {{items}}.","budget":"à votre budget","place":"à {{place}}","surface":"à la surface souhaitée","bedrooms":"au nombre de chambres","attributes":"aux équipements : {{items}}","budgetAbove":"Le prix dépasse votre budget de {{percent}} %.","budgetBelow":"Le prix est inférieur de {{percent}} % à votre budget minimum.","priceUnknown":"Le prix n'est pas indiqué.","surfaceBelow":"La surface est inférieure de {{percent}} % à votre demande.","surfaceAbove":"La surface dépasse votre demande de {{percent}} %.","surfaceUnknown":"La surface n'est pas indiquée.","locationSameCity":"Située à {{place}} : même ville, autre délégation.","bedroomsMissing":"Il manque {{count}} chambre(s).","attributesMissing":"Sans : {{items}}.","typeOther":"Le type de bien est différent.","locationOther":"La ville est différente."},"propose":{"title":"Proposer un bien","action":"Proposer un bien","choose":"Choisissez un bien à proposer","onlyOwn":"Seules vos annonces actives correspondant à cette recherche sont listées.","none":"Vous n'avez aucune annonce active de ce type.","noneFor":"Vous n'avez aucune annonce active de type « {{type}} ». Cette recherche concerne : {{transaction}}.","createListing":"Publier une annonce","select":"Sélectionner : {{title}}","message":"Message (facultatif)","messagePlaceholder":"Présentez votre bien en quelques mots.","messageNotice":"N'écrivez ni téléphone, ni e-mail, ni lien : ils seraient masqués. La personne vous contactera via Lina Immo.","submit":"Envoyer la proposition","sending":"Envoi…","sent":"Votre proposition a été envoyée.","alreadyProposed":"Déjà proposé","withdraw":"Retirer ma proposition","withdrawn":"Proposition retirée.","closed":"Cette recherche n'accepte plus de propositions.","ownRequest":"C'est votre propre recherche : vous ne pouvez pas y proposer un bien.","scoreNotice":"Le niveau de correspondance est calculé automatiquement. Vous pouvez proposer un bien partiel : la personne verra les écarts."},"level":{"excellent":"Excellent","good":"Bon","partial":"Partiel"},"received":{"show":"Voir les propositions ({{count}})","hide":"Masquer les propositions","title":"Propositions reçues","newCount":"{{count}} nouvelle(s)","newBadge":"Nouvelle","none":"Aucune proposition pour le moment.","from":"Proposé par {{name}}","fromUnknown":"Proposé par un annonceur","date":"le {{date}}","message":"Message de l'annonceur","unavailable":"Cette annonce n'est plus disponible.","loading":"Chargement des propositions…"}},
    "administration": {"visitorsTitle":"Visiteurs","visitorsToday":"Aujourd'hui","visitorsTotal":"Total depuis le lancement","visitorsLast7Days":"7 derniers jours","visitorsCount":"Visiteurs","visitorsError":"Statistiques des visiteurs indisponibles.","listingTitle":"Titre","amount":"Montant","title":"Administration Lina Immo","overview":"Tableau de bord","listings":"Annonces","vacations":"Vacances","users":"Utilisateurs","reservations":"Réservations","navigation":"Administration","back":"Retour au site","loading":"Chargement…","denied":"Accès réservé aux administrateurs","signIn":"Se connecter","search":"Titre ou auteur","searchUsers":"Nom ou e-mail","city":"Ville","delegation":"Délégation","type":"Type","status":"Statut","all":"Tous","active":"Publiée","deleted":"Supprimée","sale":"Vente","rent":"Location","night":"Vacances / nuit","filter":"Filtrer","reset":"Réinitialiser","retry":"Réessayer","sales":"Ventes","rents":"Locations","lands":"Terrains","pending":"Réservations en attente","total":"{{count}} résultat(s)","photo":"Photo","author":"Auteur","price":"Prix","date":"Date","actions":"Actions","name":"Nom","email":"E-mail","registeredAt":"Inscription","role":"Rôle","listingCount":"Annonces actives","host":"Hôte","traveler":"Voyageur","arrival":"Arrivée","departure":"Départ","view":"Voir l’annonce","viewAuthor":"Voir l’auteur","delete":"Supprimer définitivement","deleteQuestion":"Supprimer définitivement cette annonce ?","deleteNote":"L’annonce sera retirée du site. Les historiques liés aux conversations et réservations sont conservés selon les règles existantes.","cancel":"Annuler","deleting":"Suppression…","empty":"Aucun résultat","previous":"Précédent","next":"Suivant","page":"Page {{number}}","currency":"DT","Admin":"Admin","User":"Utilisateur","EnAttente":"En attente","Acceptee":"Acceptée","Rejetee":"Rejetée","Annulee":"Annulée"},
    "publisher": {"title":"Publié par","role":"Annonceur","message":"Message","phone":"Téléphone","send":"Envoyer","sending":"Envoi…","sent":"Message envoyé."},
    "saveSearch": {"question":"Enregistrer cette recherche ?","save":"Enregistrer","saving":"Enregistrement…","dismiss":"Non merci","saved":"Recherche enregistrée dans vos recherches récentes.","error":"Impossible d'enregistrer cette recherche."},
    "seo": {"categorySale":"Biens à vendre en Tunisie","categoryRent":"Biens à louer en Tunisie","categoryAll":"Annonces immobilières en Tunisie","offers":"Offres immobilières en Tunisie","vacation":"Locations de vacances en Tunisie","city":"Biens immobiliers à {{city}}","searchCity":"Annonces immobilières à {{city}}","requests":"Recherches immobilières","request":"Je recherche un bien","listing":"Annonce immobilière","vacationListing":"Location de vacances","notFound":"Annonce introuvable"},
    "mobile": {"search":"Rechercher une annonce","notifications":"Notifications","filters":"Filtres","closeFilters":"Fermer les filtres","popular":"Destinations populaires","viewMap":"Voir sur la carte","favorites":"Mes favoris","arrival":"Arrivée","departure":"Départ","language":"Langue"},
    "mapZone": {
"bedrooms":"{{count}} chambre(s)",
"perSquareMetre":"{{price}} TND/m²",
  "draw": "Dessiner une zone",
  "edit": "Modifier la zone",
  "clear": "Effacer la zone",
  "apply": "Valider la zone",
  "undo": "Retirer le dernier sommet",
  "cancel": "Annuler",
  "instructions": "Touchez la carte pour ajouter des sommets. Pour déplacer un sommet, touchez-le puis touchez sa nouvelle position. Validez pour appliquer.",
  "moveVertex": "Touchez la nouvelle position du sommet.",
  "invalid": "Tracez un polygone de 3 sommets minimum, sans croisement.",
  "empty": "Aucune annonce chargée dans cette zone.",
  "loaded": "Recherche dans la zone : {{count}} annonce(s) parmi les résultats actuellement chargés.",
  "all": "Toutes les annonces chargées",
  "indicative": "Bâtiments 3D indicatifs : les hauteurs peuvent être estimées par la source cartographique."
},
    "mapView": {
      "about": "À propos de la carte",
      "searchArea": "Voir les {{count}} biens chargés dans cette zone",
      "sameLocation": "À cette adresse",
      "previous": "Annonce précédente",
      "next": "Annonce suivante",
      "choose":"Choisir une annonce du groupe",
      "display":"Affichage des résultats","list":"Liste","map":"Carte","loading":"Chargement de la carte…",
      "count":"{{count}} bien(s) affiché(s) sur la carte","loadedOnly":"La carte représente uniquement les résultats déjà chargés. Utilisez « Voir plus » pour afficher les suivants.",
      "excluded":"{{count}} annonce(s) chargée(s) sans position exploitable : consultez-les en mode Liste.",
      "noCoordinates":"Aucune des annonces chargées ne dispose d’une position exploitable.",
      "noProvider":"Le fond de carte n’est pas configuré. Les positions restent consultables ; vous pouvez aussi revenir à la liste.",
      "tileError":"Le fond de carte est temporairement indisponible. Les marqueurs et le mode Liste restent accessibles.",
      "unavailable":"La carte n’a pas pu être chargée. Revenez au mode Liste pour consulter les annonces.",
      "cluster":"{{count}} annonces : agrandir ou déplier le groupe","preview":"Aperçu de l’annonce","close":"Fermer l’aperçu",
      "noPrice":"Voir l’annonce","price":"{{price}} TND","monthlyPrice":"{{price}} TND/mois","nightlyPrice":"{{price}} TND/nuit"
    },
    "listingSort": {"label":"Trier par :","recent":"Plus récentes","price_asc":"Prix croissant","price_desc":"Prix décroissant","price_m2_asc":"Prix au m² croissant","price_m2_desc":"Prix au m² décroissant","surface_asc":"Surface croissante","surface_desc":"Surface décroissante","bedrooms_asc":"Nombre de chambres croissant","bedrooms_desc":"Nombre de chambres décroissant","night_price_asc":"Prix par nuit croissant","night_price_desc":"Prix par nuit décroissant"},
    "vacationPrice": {"price":"Prix","minimum":"Prix minimum","maximum":"Prix maximum","unit":"TND / nuit","apply":"Appliquer","from":"À partir de","until":"Jusqu’à","invalid":"Saisissez des prix positifs ou nuls, avec un minimum inférieur ou égal au maximum."},
    "stay": {"weeklyDiscount":"Remise semaine","monthlyDiscount":"Remise mensuelle","estimatedTotal":"Total estimé","leaveDraft":"Quitter ce formulaire et perdre les informations non enregistrées ?"},
    "publicEmail": {
      "title": "Contact",
      "intro": "Une question sur Lina Immo ? Retrouvez ci-dessous nos coordonnées.",
      "home": "Accueil",
      "address": "Adresse",
      "city": "Kairouan, Tunisie",
      "telephone": "Téléphone",
      "whatsappHint": "Ouvre WhatsApp dans un nouvel onglet",
      "formTitle": "Envoyez-nous un message",
      "lastName": "Nom",
      "firstName": "Prénom",
      "email": "E-mail",
      "phone": "Téléphone (facultatif)",
      "message": "Message",
      "send": "Envoyer",
      "sending": "Envoi en cours…",
      "required": "Ce champ est obligatoire.",
      "invalidEmail": "Veuillez saisir une adresse e-mail valide.",
      "contactSuccess": "Votre message a été envoyé. Merci de nous avoir contactés.",
      "sendError": "L’envoi n’a pas pu être confirmé. Veuillez réessayer plus tard.",
      "notConfigured": "L’envoi est temporairement indisponible. Veuillez réessayer plus tard.",
      "newsletterTitle": "Restez informé avec Lina Immo",
      "newsletterText": "Recevez les nouvelles annonces, les nouveautés et les actualités de Lina Immo directement par e-mail.",
      "emailPlaceholder": "Votre adresse e-mail",
      "subscribe": "S’inscrire",
      "newsletterSuccess": "Votre demande d’inscription à la newsletter a été envoyée. Merci !"
},
    "my_profile": "Mon profil",
    "want_to_edit_name": "Modifier votre nom ?",
    "edit": "Modifier",
    "apply_changes": "Enregistrer",
    "logout": "Se déconnecter",
    "delete_account": "Supprimer mon compte",
    "delete_reason_placeholder": "Raison de la suppression (facultatif)",
    "confirm_delete_account": "Supprimer définitivement",
    "fill_reason_before_delete": "Vous pouvez indiquer la raison de votre départ.",
    "profile_updated": "Profil mis à jour.",
    "profile_update_error": "Impossible de mettre à jour votre profil.",
    "account_deleted": "Votre compte a été supprimé.",
    "account_delete_error": "Impossible de supprimer votre compte.",
    "show_conversations": "Afficher les conversations",
    "hide_conversations": "Masquer les conversations",
    "write_message": "Écrivez votre message…",
    "send": "Envoyer",
    "location_Vacation": "Trouvez votre location de vacances",
    "location_day": "Location par jour",
    "email_placeholder": "Adresse email",
    "reset_password": "Réinitialiser le mot de passe",
    "email_sent": "L'e-mail a été envoyé",
    "reset_password_error": "Impossible d'envoyer le mot de passe de réinitialisation",
    "message": "Message",
    "call": "Appeler",
    "sign_up": "S'inscrire",
    "password_placeholder": "Mot de passe",
    "confirmation_password": "Confirmer le mot de passe",
    "incorrect_email_password": "Email et/ou mot de passe incorrect",
    "no_account": "Vous n'avez pas de compte ?",
    "sign_in": "Se connecter",
    "forgot_password": "Mot de passe oublié ?",
    "or": "OU",
    "amenities": {
      "wifi": "Wi-Fi",
      "workspace": "Espace de travail dédié",
      "parking": "Parking gratuit sur place",
      "piscine": "Piscine intérieure privée",
      "tv": "TV",
      "camera": "Caméras de surveillance",
      "barbecue": "Barbecue",
      "beachAccess": "Accès à la plage",
      "ac": "Climatisation"
    },
    "find_your_dream_property": "Trouvez votre propriété de rêve",
    "no_conversation": "Aucune conversation",
    "details_vacation": {
      "sending": "Envoi...",
      "send_reservation": "Envoyer la demande",
      "sending_in_progress": "Envoi de votre réservation...",
      "reservation_sent": "Votre demande de réservation a été envoyée.",
      "contact_us": "Contactez-nous",
      "our_cities": "Explorer par ville",
      "title": "Informations sur l'appartement",
      "guests": "{{count}} voyageur(s)",
      "bedrooms": "{{count}} chambre(s) · {{beds}} lit(s)",
      "bathrooms": "salle(s) de bain",
      "amenities": "Équipements",
      "arrival_date": "Arrivée",
      "departure_date": "Départ",
      "name": "Nom",
      "email": "E-mail",
      "phone": "Téléphone",
      "message": "Message",
      "total_days": "Nombre de jours :",
      "total_price": "Total estimé",
      "discount_applied": "Réduction",
      "per_night": "par nuit",
      "no_listings": "Actuellement, il n'y a pas d'annonces.",
      "follow_us": "Suivez-nous",
      "newsletter": "Newsletter",
      "newsletter_text": "Recevez les dernières annonces et les nouvelles opportunités immobilières.",
      "your_email": "Votre e-mail",
      "subscribe": "S'inscrire",
      "selectDay": "Sélectionner",
      "invalid_email": "Veuillez saisir une adresse e-mail valide.",
      "login_required": "Veuillez vous connecter pour effectuer une réservation.",
      "invalid_dates": "Sélectionnez des dates valides.",
      "email_error": "Une erreur est survenue lors de l’envoi.",
      "reserve": "Réserver",
      "booking_request": "Demande de réservation",
      "nights": "nuits",
      "load_error": "Impossible de charger cette location.",
      "network_error": "Une erreur réseau est survenue.",
      "load_error_title": "Impossible de charger cette location",
      "no_amenities": "Aucun équipement renseigné."
    },
    "profile": {
      "succes": "Suppression réussie",
      "echec": "La suppression a échoué",
      "user_not_connected": "Utilisateur non connecté.",
      "loading_error": "Impossible de charger vos annonces.",
      "confirm_delete": "Êtes-vous sûr de vouloir supprimer cette annonce ?",
      "delete_error": "Erreur lors de la suppression.",
      "my_space": "Mon espace immobilier",
      "my_annonce": "Mes annonces",
      "no_published_ads": "Vous n’avez encore publié aucune annonce.",
      "refresh": "Actualiser",
      "empty_ads_description": "Publiez votre premier bien immobilier ou votre première location de vacances.",
      "vacation_ads": "Locations de vacances",
      "property_ads": "Biens immobiliers",
      "logout_error": "Impossible de vous déconnecter.",
      "name_required": "Le nom ne peut pas être vide.",
      "no_changes": "Aucune modification détectée.",
      "final_delete_confirm": "Cette action est définitive. Voulez-vous vraiment supprimer votre compte ?",
      "recent_login_required": "Pour des raisons de sécurité, reconnectez-vous avant de supprimer votre compte.",
      "description": "Gérez vos informations personnelles et les paramètres de votre compte.",
      "user": "Utilisateur",
      "name": "Nom",
      "email": "E-mail",
      "email_notice": "L’adresse e-mail est liée à votre compte de connexion.",
      "saving": "Enregistrement...",
      "session": "Session",
      "session_description": "Vous pouvez vous déconnecter de votre compte à tout moment.",
      "danger_zone": "Zone sensible",
      "delete_description": "La suppression de votre compte est définitive et ne peut pas être annulée.",
      "delete_confirm_title": "Confirmer la suppression",
      "delete_reason_text": "Vous pouvez nous indiquer pourquoi vous souhaitez supprimer votre compte.",
      "deleting": "Suppression...",
      "ads": "annonces",
      "ad": "annonce",
      "published_ads": "annonces publiées",
      "published_ad": "annonce publiée"
    },
    "lord": "Les voyageurs",
    "arrival": "Arrivé",
    "destination": "Destination",
    "travelers": "Voyageurs",
    "add_travelers": "Ajouter des voyageurs",
    "depart": "Départ",
    "continue": "Continuer",
    "previous": "Précédent",
    "entirePlace": "LOGEMENT ENTIER",
    "oneRoom": "UNE CHAMBRE",
    "sharedRoom": "UNE CHAMBRE PARTAGÉE",
    "listing": {
      "alreadyContacted": "Déjà contacté",
      "alreadyContactedMessage": "Vous avez déjà contacté le propriétaire de ce bien.",
      "noData": "Cette annonce est introuvable.",
      "contactLandlord": "Contacter l’annonceur",
      "name": "Nom",
      "email": "E-mail",
      "phone": "Téléphone", 
      "WhatsApp": "WhatsApp", 
      "addMessage": "Message",
      "description": "Description",
      "shareLinkCopied": "Lien copié",
      "rent": "À louer",
      "sale": "À vendre",
      "bedroom": " Chambre",
      "bedrooms": "Chambres",
      "bathroom": " Salle de bain",
      "parking": "Parking",
      "noParking": "Sans parking",
      "furnished": "Meublé",
      "notFurnished": "Non meublé",
      "showNumber": "Voir le numéro",
      "message": "Bonjour, votre bien m'intéresse, est-il toujours disponible ?",
      "available": "Disponible",
      "month": "mois",
      "untitled": "Annonce immobilière",
      "locationUnavailable": "Localisation non précisée",
      "bedroomsShort": "ch.",
      "bathroomsShort": "SDB",
      "surface": "Surface",
      "viewLand": "Voir le terrain",
      "viewDetails": "Voir le logement",
      "new": "Nouveau",
      "bathrooms": "SDB",
      "loadingError": "Impossible de charger cette annonce.",
      "completeFields": "Veuillez compléter tous les champs.",
      "networkError": "Une erreur réseau est survenue.",
      "loadingTitle": "Impossible de charger l’annonce",
      "property": "Annonce immobilière",
      "youSave": "Économisez",
      "noDescription": "Aucune description disponible.",
      "location": "Localisation",
      "openMaps": "Ouvrir dans Maps",
      "contactDescription": "Obtenez plus d’informations ou organisez une visite de ce bien.",
      "messageSent": "Votre message a bien été envoyé.",
      "sendMessage": "Envoyer un message",
      "namePlaceholder": "Votre nom",
      "send": "Envoyer le message",
      "ownerNotice": "Vous êtes le propriétaire de cette annonce."
    },
    "create_ad": "Déposer une annonce",
    "No_ads": "Il n'y a pas des annonces actuellement",
    "No_request": "Aucune demande pour le moment",
    "No_reserved": "Aucune réservation pour le moment",
    "ads": "Les annonces",
    "create_adW": "Publier une location de vacances",
    "update_ad": "Mettre à jour la location",
    "sell / rent": "Vente ou location",
    "sell": "Vendre",
    "rent": "Louer",
    "choose_property_type": "Type de bien",
    "apartment": "Appartement",
    "house": "Maison",
    "commercial": "Commercial",
    "land": "Terrain",
    "others": "Autres",
    "label": "Titre de l’annonce",
    "description": "Description",
    "surface": "Surface",
    "price": "Prix",
    "city": "Toutes les villes",
    "delegation": "Toutes les délégations",
    "offer": "Offre spéciale",
    "yes": "Oui",
    "no": "Non",
    "address": "Adresse",
    "postal_code": "Code postal",
    "bathrooms": "SDB",
    "bathroom": "Salle de Bain",
    "beds": "lits",
    "bedrooms": "chambres",
    "parking": "Parking",
    "furnished": "Meublé",
    "add_image": "Ajouter une image",
    "add_ad": "Déposer une annonce",
    "add_ad_short": "Déposer",
    "choose_file": "Choisir un fichier",
    "no_file_selected": "Aucun fichier n'a été sélectionné",
    "create_ad_button": "Créer l'annonce",
    "Kairouan": "Kairouan",
    "home": "Accueil",
    "buy": "Acheter",
    "offers": "Offres",
    "recent_offers": "Offres récentes",
    "Contacts": "Vos coordonnées",
    "SoldeW": "Réduction hebdomadaire",
    "SoldeW_": "Pour un séjour d’une semaine",
    "SoldeM": "Réduction mensuelle",
    "SoldeM_": "Pour un séjour d’un mois",
    "see_all_offers": "Voir toutes nos offres",
    "see_plus": "Voir plus",
    "no_exact_match": "Aucune location trouvée",
    "modify_filters": "Modifiez votre destination ou le nombre de voyageurs pour découvrir plus de logements.",
    "for_rent": "À louer",
    "see_all_ads": "Voir toutes nos annonces",
    "for_sale": "À vendre",
    "fetch_fail": "Échec de la récupération des données",
    "fetch_error": "Une erreur s'est produite :",
    "my_favorites": "Mes favoris",
    "recent_searches": "Recherches récentes",
    "recently_viewed": "Récemment consultées",
    "my_annonce": "Mes annonces",
    "my_reservation": "Mes réservations",
    "my_message": "Messages",
    "my_profil": "Mon profil",
    "my_demande": "Demandes de réservation",
    "my_alerts": "Mes alertes",
    "SelectCity": "Sélectionner une ville",
    "numtel": "Téléphone",
    "email": "E-mail",
    "vacances": "Vacances",
    "guesthouse": "Hôte",
    "partyrooms": "Salles de fêtes",
    "upload": "Déposez des images ou appuyez sur le bouton",
    "guestNumbers": "Nombres des personnes",
    "month": "Mois",
    "cities": {
      "Tunis": "Tunis",
      "Sfax": "Sfax",
      "Kairouan": "Kairouan",
      "Ariana": "Ariana",
      "Béja": "Béja",
      "Ben Arous": "Ben Arous",
      "Bizerte": "Bizerte",
      "Gabès": "Gabès",
      "Gafsa": "Gafsa",
      "Jendouba": "Jendouba",
      "Kasserine": "Kasserine",
      "Kébili": "Kébili",
      "Kef": "Le Kef",
      "Mahdia": "Mahdia",
      "Manouba": "Manouba",
      "Médenine": "Médenine",
      "Monastir": "Monastir",
      "Nabeul": "Nabeul",
      "Sidi Bouzid": "Sidi Bouzid",
      "Siliana": "Siliana",
      "Sousse": "Sousse",
      "Tataouine": "Tataouine",
      "Tozeur": "Tozeur",
      "Zaghouan": "Zaghouan",
      "Le Kef": "Le Kef",
      "Hammamet": "Hammamet"
    },
    "delegations": {
      "Tunis": {
        "Bab El Bhar": "Bab El Bhar",
        "Bab Souika": "Bab Souika",
        "Carthage": "Carthage",
        "Cité El Khadra": "Cité El Khadra",
        "Djebel Jelloud": "Djebel Jelloud",
        "El Kabaria": "El Kabaria",
        "El Menzah": "El Menzah",
        "El Omrane": "El Omrane",
        "El Omrane Supérieur": "El Omrane Supérieur",
        "El Ouardia": "El Ouardia",
        "Ettahrir": "Ettahrir",
        "Ezzouhour": "Ezzouhour",
        "Hrairia": "Hrairia",
        "La Goulette": "La Goulette",
        "La Marsa": "La Marsa",
        "Le Bardo": "Le Bardo",
        "Le Kram": "Le Kram",
        "Médina": "Médina",
        "Séjoumi": "Séjoumi",
        "Sidi El Béchir": "Sidi El Béchir",
        "Sidi Hassine": "Sidi Hassine"
      },
      "Sfax": {
        "Sakiet Eddaier": "Sakiet Eddaier",
        "Sakiet Ezzit": "Sakiet Ezzit",
        "Sfax Ouest": "Sfax Ouest",
        "Sfax Sud": "Sfax Sud",
        "Sfax Ville": "Sfax Ville",
        "Thyna": "Thyna",
        "El Amra": "El Amra",
        "El Hencha": "El Hencha",
        "Graïba": "Graïba",
        "Jebeniana": "Jebeniana",
        "Kerkennah": "Kerkennah",
        "Mahrès": "Mahrès",
        "Menzel Chaker": "Menzel Chaker"
      },
      "Kairouan": {
        "Kairouan Nord": "Kairouan Nord",
        "Kairouan Sud": "Kairouan Sud",
        "Chebika": "Chebika",
        "Sbikha": "Sbikha",
        "Haffouz": "Haffouz",
        "Hajeb El Ayoun": "Hajeb El Ayoun",
        "Oueslatia": "Oueslatia",
        "Bou Hajla": "Bou Hajla",
        "Nasrallah": "Nasrallah",
        "Chrarda": "Chrarda"
      },
      "Ariana": {
        "Ariana Ville": "Ariana Ville",
        "Ettadhamen": "Ettadhamen",
        "Kalaat el Andalous": "Kalaat el Andalous",
        "La Soukra": "La Soukra",
        "Mnihla": "Mnihla",
        "Raoued": "Raoued",
        "Sidi Thabet": "Sidi Thabet"
      },
      "Béja": {
        "Amdoun": "Amdoun",
        "Béja Nord": "Béja Nord",
        "Béja Sud": "Béja Sud",
        "Goubellat": "Goubellat",
        "Medjez el Bab": "Medjez el Bab",
        "Nefza": "Nefza",
        "Téboursouk": "Téboursouk",
        "Testour": "Testour",
        "Thibar": "Thibar"
      },
      "Ben Arous": {
        "Ben Arous": "Ben Arous",
        "Bou Mhel el Bassatine": "Bou Mhel el Bassatine",
        "El Mourouj": "El Mourouj",
        "Ezzahra": "Ezzahra",
        "Fouchana": "Fouchana",
        "Hammam Chott": "Hammam Chott",
        "Hammam Lif": "Hammam Lif",
        "Mohamedia": "Mohamedia",
        "Mornag": "Mornag",
        "Nouvelle Medina": "Nouvelle Medina",
        "Radès": "Radès"
      },
      "Bizerte": {
        "Bizerte Nord": "Bizerte Nord",
        "Bizerte Sud": "Bizerte Sud",
        "Djoumine": "Djoumine",
        "El Alia": "El Alia",
        "Ghar El Melh": "Ghar El Melh",
        "Ghezala": "Ghezala",
        "Joumine": "Joumine",
        "Mateur": "Mateur",
        "Menzel Bourguiba": "Menzel Bourguiba",
        "Menzel Jemil": "Menzel Jemil",
        "Ras Jebel": "Ras Jebel",
        "Sejenane": "Sejenane",
        "Tinja": "Tinja",
        "Utique": "Utique",
        "Zarzouna": "Zarzouna"
      },
      "Gabès": {
        "Gabès Ville": "Gabès Ville",
        "Gabès Ouest": "Gabès Ouest",
        "Gabès Sud": "Gabès Sud",
        "Ghannouch": "Ghannouch",
        "Mareth": "Mareth",
        "Matmata": "Matmata",
        "Menzel Habib": "Menzel Habib",
        "Métouia": "Métouia",
        "Nouvelle Matmata": "Nouvelle Matmata"
      },
      "Gafsa": {
        "Belkhir": "Belkhir",
        "El Guettar": "El Guettar",
        "El Ksar": "El Ksar",
        "Gafsa Nord": "Gafsa Nord",
        "Gafsa Sud": "Gafsa Sud",
        "Mdhilla": "Mdhilla",
        "Metlaoui": "Metlaoui",
        "Moularès": "Moularès",
        "Redeyef": "Redeyef",
        "Sened": "Sened",
        "Sidi Aïch": "Sidi Aïch"
      },
      "Jendouba": {
        "Aïn Draham": "Aïn Draham",
        "Balta-Bou Aouane": "Balta-Bou Aouane",
        "Bou Salem": "Bou Salem",
        "Fernana": "Fernana",
        "Ghardimaou": "Ghardimaou",
        "Jendouba Nord": "Jendouba Nord",
        "Jendouba Sud": "Jendouba Sud",
        "Oued Meliz": "Oued Meliz",
        "Tabarka": "Tabarka"
      },
      "Kasserine": {
        "Djedeliane": "Djedeliane",
        "El Ayoun": "El Ayoun",
        "Ezzouhour": "Ezzouhour",
        "Fériana": "Fériana",
        "Foussana": "Foussana",
        "Haïdra": "Haïdra",
        "Hassi El Ferid": "Hassi El Ferid",
        "Kasserine Nord": "Kasserine Nord",
        "Kasserine Sud": "Kasserine Sud",
        "Majel Bel Abbès": "Majel Bel Abbès",
        "Sbeitla": "Sbeitla",
        "Sbiba": "Sbiba",
        "Thala": "Thala"
      },
      "Kébili": {
        "Douz Nord": "Douz Nord",
        "Douz Sud": "Douz Sud",
        "Faouar": "Faouar",
        "Kébili Nord": "Kébili Nord",
        "Kébili Sud": "Kébili Sud",
        "Souk Lahad": "Souk Lahad"
      },
      "Le Kef": {
        "Dahmani": "Dahmani",
        "Jérissa": "Jérissa",
        "El Ksour": "El Ksour",
        "Le Kef Est": "Le Kef Est",
        "Le Kef Ouest": "Le Kef Ouest",
        "Ksour": "Ksour",
        "Nebeur": "Nebeur",
        "Sakiet Sidi Youssef": "Sakiet Sidi Youssef",
        "Sers": "Sers",
        "Tajerouine": "Tajerouine"
      },
      "Mahdia": {
        "Bou Merdes": "Bou Merdes",
        "Chorbane": "Chorbane",
        "El Jem": "El Jem",
        "Essouassi": "Essouassi",
        "Hebira": "Hebira",
        "Ksour Essef": "Ksour Essef",
        "Mahdia": "Mahdia",
        "Melloulech": "Melloulech",
        "Ouled Chamekh": "Ouled Chamekh",
        "Sidi Alouane": "Sidi Alouane"
      },
      "Manouba": {
        "Borj El Amri": "Borj El Amri",
        "Douar Hicher": "Douar Hicher",
        "El Battan": "El Battan",
        "Jedaida": "Jedaida",
        "La Manouba": "La Manouba",
        "Mornaguia": "Mornaguia",
        "Oued Ellil": "Oued Ellil",
        "Tebourba": "Tebourba"
      },
      "Médenine": {
        "Ben Gardane": "Ben Gardane",
        "Beni Khedache": "Beni Khedache",
        "Djerba - Ajim": "Djerba - Ajim",
        "Djerba - Houmt Souk": "Djerba - Houmt Souk",
        "Djerba - Midoun": "Djerba - Midoun",
        "Médenine Nord": "Médenine Nord",
        "Médenine Sud": "Médenine Sud",
        "Sidi Makhlouf": "Sidi Makhlouf",
        "Zarzis": "Zarzis"
      },
      "Monastir": {
        "Bekalta": "Bekalta",
        "Bembla": "Bembla",
        "Beni Hassen": "Beni Hassen",
        "Jemmal": "Jemmal",
        "Ksar Hellal": "Ksar Hellal",
        "Ksibet el Mediouni": "Ksibet el Mediouni",
        "Moknine": "Moknine",
        "Monastir": "Monastir",
        "Ouerdanine": "Ouerdanine",
        "Sahline": "Sahline",
        "Sayada-Lamta-Bou Hjar": "Sayada-Lamta-Bou Hjar",
        "Teboulba": "Teboulba",
        "Zéramdine": "Zéramdine"
      },
      "Nabeul": {
        "Béni Khalled": "Béni Khalled",
        "Béni Khiar": "Béni Khiar",
        "Bou Argoub": "Bou Argoub",
        "Dar Chaâbane El Fehri": "Dar Chaâbane El Fehri",
        "El Haouaria": "El Haouaria",
        "El Mida": "El Mida",
        "Grombalia": "Grombalia",
        "Hammam Ghezèze": "Hammam Ghezèze",
        "Hammamet": "Hammamet",
        "Kélibia": "Kélibia",
        "Korba": "Korba",
        "Menzel Bouzelfa": "Menzel Bouzelfa",
        "Menzel Temime": "Menzel Temime",
        "Nabeul": "Nabeul",
        "Soliman": "Soliman",
        "Takelsa": "Takelsa"
      },
      "Sidi Bouzid": {
        "Bir El Hafey": "Bir El Hafey",
        "Cebbala Ouled Asker": "Cebbala Ouled Asker",
        "Jilma": "Jilma",
        "Meknassy": "Meknassy",
        "Mezzouna": "Mezzouna",
        "Menzel Bouzaiane": "Menzel Bouzaiane",
        "Ouled Haffouz": "Ouled Haffouz",
        "Regueb": "Regueb",
        "Sidi Ali Ben Aoun": "Sidi Ali Ben Aoun",
        "Sidi Bouzid Est": "Sidi Bouzid Est",
        "Sidi Bouzid Ouest": "Sidi Bouzid Ouest",
        "Souk Jedid": "Souk Jedid"
      },
      "Siliana": {
        "Bargou": "Bargou",
        "Bou Arada": "Bou Arada",
        "El Aroussa": "El Aroussa",
        "Gaâfour": "Gaâfour",
        "El Krib": "El Krib",
        "Makthar": "Makthar",
        "Rouhia": "Rouhia",
        "Sidi Bou Rouis": "Sidi Bou Rouis",
        "Siliana Nord": "Siliana Nord",
        "Siliana Sud": "Siliana Sud",
        "Kesra": "Kesra"
      },
      "Sousse": {
        "Bouhsina": "Bouhsina",
        "Chott Meriem": "Chott Meriem",
        "Kantaoui": "Kantaoui",
        "Khzema": "Khzema",
        "Messaadine": "Messaadine",
        "Swisse": "Swisse",
        "Tafala": "Tafala",
        "Ksiba": "Ksiba",
        "Akouda": "Akouda",
        "Bouficha": "Bouficha",
        "Enfidha": "Enfidha",
        "Hammam Sousse": "Hammam Sousse",
        "Hergla": "Hergla",
        "Kalâa Kebira": "Kalâa Kebira",
        "Kalâa Seghira": "Kalâa Seghira",
        "Kondar": "Kondar",
        "Msaken": "Msaken",
        "Sidi Bou Ali": "Sidi Bou Ali",
        "Sidi El Hani": "Sidi El Hani",
        "Sousse Jawhara": "Sousse Jawhara",
        "Sousse Médina": "Sousse Médina",
        "Sousse Riadh": "Sousse Riadh",
        "Sousse Sidi Abdelhamid": "Sousse Sidi Abdelhamid",
        "Sahloul": "Sahloul",
        "Cité Zouhour": "Cité Zouhour",
        "Thrayat": "Thrayat",
        "Zawiya": "Zawiya",
        "Cité Manazah": "Cité Manazah"
      },
      "Tataouine": {
        "Bir Lahmar": "Bir Lahmar",
        "Dehiba": "Dehiba",
        "Ghomrassen": "Ghomrassen",
        "Remada": "Remada",
        "Samar": "Samar",
        "Tataouine Nord": "Tataouine Nord",
        "Tataouine Sud": "Tataouine Sud"
      },
      "Tozeur": {
        "Degache": "Degache",
        "Hamet Jerid": "Hamet Jerid",
        "Nefta": "Nefta",
        "Tozeur": "Tozeur",
        "Tameghza": "Tameghza"
      },
      "Zaghouan": {
        "Bir Mcherga": "Bir Mcherga",
        "El Fahs": "El Fahs",
        "Nadhour": "Nadhour",
        "Saouaf": "Saouaf",
        "Zaghouan": "Zaghouan",
        "Zriba": "Zriba"
      },
      "Kef": {
        "Dahmani": "Dahmani",
        "Jérissa": "Jérissa",
        "El Ksour": "El Ksour",
        "Le Kef Est": "Le Kef Est",
        "Le Kef Ouest": "Le Kef Ouest",
        "Ksour": "Ksour",
        "Nebeur": "Nebeur",
        "Sakiet Sidi Youssef": "Sakiet Sidi Youssef",
        "Sers": "Sers",
        "Tajerouine": "Tajerouine",
        "Kef Est": "Le Kef Est",
        "Kef Ouest": "Le Kef Ouest"
      }
    },
    "rooms": "Chambres",
    "conversations": "Conversations",
    "piece": "pièces",
    "room": "Chambre",
    "delete": "Supprimer",
    "search_form": {
      "search_placeholder": "Appartement, villa, terrain...",
      "advanced_search": "Recherche avancée",
      "label": "Mot-clé",
      "hide_advanced_search": "Masquer les filtres",
      "all_cities": "Toutes les villes",
      "all_delegations": "Toutes les délégations",
      "min_price": "Prix minimum",
      "max_price": "Prix maximum",
      "all_categories": "Toutes les catégories",
      "category": "Catégorie",
      "search": "Rechercher",
      "reset": "Réinitialiser les filtres",
      "rooms": "Nombre de pièces",
      "select_rooms": "Nombre de pièces",
      "search_title": "Trouvez votre futur logement",
      "search_description": "Sélectionnez une ville puis affinez votre recherche selon vos critères.",
      "you_have": "لديك",
      "pending_notifications": "إشعارات معلقة",
      "name": "الاسم",
      "select_category": "Sélectionnez une catégorie"
    },
    "title": "Logement",
    "enterAdres": "Saisissez une adresse",
    "options": {
      "description": "Équipements et services",
      "wifi": "Wi-Fi",
      "tv": "Tv",
      "cuisine": "Cuisine",
      "lavelinge": "Lave-linge",
      "Parking": "Parking",
      "climatisation": "Climatisation",
      "espacedetravail": "Espace de travail",
      "picine": "Piscine",
      "barbecue": "Barbecue",
      "jardin": "Jardin",
      "accesauplage": "Accès au plage",
      "camera": "Caméra de surveillance ",
      "parking": "Parking",
      "furnished": "Meublé"
    },
    "maps": "Localisez votre bien",
    "you_have": "Vous avez",
    "pending_notifications": "notifications en attente",
    "contact": "Contact",
    "request_date": "Demande",
    "start": "Arrivée",
    "end": "Départ",
    "status": "Statut",
    "actions": "Actions",
    "validate": "Valider",
    "cancel": "Annuler",
    "pending": "En attente",
    "confirmed": "Confirmées",
    "rejected": "Rejetée",
    "canceled": "Annulée",
    "expired": "Expirées",
    "request_list": "Demandes de réservation",
    "list_title": "Mes réservations",
    "no_title": "Aucune réservation trouvée",
    "no_requests": "Aucune demande trouvée",
    "error": "Erreur",
    "cancel_confirm": "Êtes-vous sûr de vouloir rejeter cette demande ?",
    "cancel_success": "La demande a été annulée",
    "accept_success": "Demande acceptée",
    "ui": {
      "page_not_found": "Page introuvable.",
      "home": "Accueil",
      "you_are_not_signed_in": "Utilisateur non connecté.",
      "unable_to_load_your_listings": "Impossible de charger vos annonces.",
      "are_you_sure_you_want_to_delete_this_listing": "Êtes-vous sûr de vouloir supprimer cette annonce ?",
      "deletion_failed": "La suppression a échoué.",
      "listing_deleted_successfully": "Annonce supprimée avec succès.",
      "an_error_occurred_while_deleting": "Erreur lors de la suppression.",
      "my_property_dashboard": "Mon espace immobilier",
      "my_listings": "Mes annonces",
      "you_have_not_published_any_listings_yet": "Vous n’avez encore publié aucune annonce.",
      "refresh": "Actualiser",
      "add_a_listing": "Ajouter une annonce",
      "no_listings_available": "Aucune annonce disponible",
      "publish_your_first_property_or_holiday_rental": "Publiez votre premier bien immobilier ou votre première location de vacances.",
      "list_a_property": "Publier un bien",
      "list_a_holiday_rental": "Publier une location de vacances",
      "holiday_rentals": "Locations de vacances",
      "properties": "Biens immobiliers",
      "what_this_accommodation_offers": "Ce que propose ce logement",
      "lina_immo_property_listing": "Annonce immobilière Lina Immo",
      "for_rent": "À louer",
      "for_sale": "À vendre",
      "available": "Disponible",
      "photos": "photos",
      "month": "mois",
      "property_listing": "Annonce immobilière",
      "location_not_specified": "Localisation non précisée",
      "beds": "Ch.",
      "baths": "SDB",
      "area": "Surface",
      "yes": "Oui",
      "no": "Non",
      "parking": "Parking",
      "edit": "Modifier",
      "delete": "Supprimer",
      "view_details": "Voir les détails",
      "unable_to_retrieve_the_data": "Impossible de charger les données.",
      "contact": "Contact",
      "contact_details": "Coordonnées",
      "email": "Email",
      "phone": "Téléphone",
      "WhatsApp": "WhatsApp", 
      "profile": "Profil",
      "user": "Utilisateur",
      "email_unavailable": "Email inconnu",
      "phone_number_not_provided": "Téléphone non renseigné",
      "select_a_conversation": "Sélectionnez une conversation.",
      "conversations": "Conversations",
      "search_conversations": "Rechercher une conversation",
      "listing_deleted": "Annonce supprimée",
      "about_this_listing": "À propos de cette annonce",
      "view_messages": "Voir les échanges",
      "delete_conversation": "Supprimer la conversation",
      "no_conversations_found": "Aucune conversation trouvée",
      "all_your_conversations_in_one_place": "Tous vos échanges, au même endroit.",
      "please_enter_an_address": "Veuillez saisir une adresse.",
      "address_not_found": "Adresse introuvable.",
      "unable_to_search_for_this_address_right_now": "Impossible de rechercher cette adresse pour le moment.",
      "please_enter_the_address_city_and_delegation": "Veuillez renseigner l’adresse, la ville et la délégation.",
      "address": "Adresse",
      "enter_an_address": "Saisissez une adresse",
      "search_address": "Rechercher l’adresse",
      "city": "Ville",
      "select_a_city": "Sélectionner une ville",
      "postal_code": "Code postal",
      "delegation": "Délégation",
      "select_a_delegation": "Sélectionner une délégation",
      "map_preview": "Aperçu sur la carte",
      "previous": "Précédent",
      "continue": "Continuer",
      "describe_your_property": "Décrivez votre bien !",
      "bedrooms": "Chambres",
      "bathrooms": "Salles de bain",
      "upload_images_of_your_property": "Déposez des images de votre bien",
      "unable_to_share_the_link_please_try_again": "Impossible de partager le lien. Réessayez.",
      "about_us": "À propos",
      "terms_of_use": "Conditions d’utilisation",
      "privacy_policy": "Politique de confidentialité",
      "back_to_home": "Retour à l'accueil",
      "rent_invest_negotiate_buy": "Location · Investissement · Négociation · Achat",
      "find_your_next_home_list_your_property_and_discover_real_estate_opportunities_across_tunisia": "Trouvez facilement votre futur logement, publiez votre bien et découvrez les meilleures opportunités immobilières en Tunisie.",
      "navigation": "Navigation",
      "explore_by_city": "Explorer par ville",
      "discover_available_properties_in_the_most_popular_cities": "Découvrez les biens disponibles dans les villes les plus recherchées.",
      "show_less": "Voir moins",
      "view_all_cities": "Voir toutes les villes",
      "keep_in_touch": "Restons en contact",
      "email_94": "E-mail",
      "kairouan_tunisia": "Kairouan, Tunisie",
       "paris_france": "Paris, France",
      "newsletter": "Newsletter",
      "get_the_latest_listings_and_new_property_opportunities": "Recevez les dernières annonces et les nouvelles opportunités immobilières.",
      "your_email": "Votre e-mail",
      "subscribe_to_the_newsletter": "S'inscrire à la newsletter",
      "sign_up": "S'inscrire",
      "lina_immo_all_rights_reserved": "Lina Immo. Tous droits réservés.",
      "privacy": "Confidentialité",
      "terms": "Conditions",
      "back_to_top": "Retour en haut",
      "menu": "Menu",
      "close_menu": "Fermer le menu",
      "sale_or_long_term_rental": "Vente ou location longue durée",
      "daily_or_holiday_rental": "Location journalière ou vacances",
      "open_menu": "Ouvrir le menu",
      "close_mobile_menu": "Fermer le menu mobile",
      "lina_immo_home": "Lina Immo — Accueil",
      "real_estate_made_simple": "L’immobilier, simplement.",
      "main_navigation": "Navigation principale",
      "mobile_menu": "Menu mobile",
      "mobile_navigation": "Navigation mobile",
      "preview": "Aperçu",
      "you_can_upload_up_to_6_images": "Vous ne pouvez pas télécharger plus de 6 images.",
      "some_files_exceed_the_5_mb_limit_and_will_not_be_added": "Certains fichiers dépassent la limite de 5 Mo et ne seront pas ajoutés.",
      "step_6": "Étape 6",
      "add_photos_of_your_property": "Ajoutez les photos de votre bien",
      "add_bright_high_quality_photos_to_make_your_listing_more_appealing": "Ajoutez des photos lumineuses et de bonne qualité pour rendre votre annonce plus attractive.",
      "upload_photos": "Importer vos photos",
      "choose_a_main_photo_then_add_the_rooms_and_amenities": "Choisissez une belle photo principale puis ajoutez les différentes pièces et les équipements.",
      "tips": "Conseils",
      "use_clear_bright_landscape_photos_avoid_blurry_or_dark_images": "Utilisez des photos horizontales, nettes et lumineuses. Évitez les images floues ou trop sombres.",
      "choose_a_language": "Choisir une langue",
      "language": "Langue",
      "view_listing": "Voir l’annonce",
      "rent": "Location",
      "sale": "Vente",
      "new": "Nouveau",
      "beds_140": "ch.",
      "listing_displayed_on_the_home_page": "Annonce affichée sur la page d’accueil",
      "no_images_available": "Aucune image disponible",
      "host": "Hôte :",
      "tnd_night": "dt / nuit",
      "please_enter_a_valid_email_address": "Veuillez saisir une adresse e-mail valide.",
      "please_sign_in_to_make_a_reservation": "Veuillez vous connecter pour effectuer une réservation.",
      "select_valid_dates": "Sélectionnez des dates valides.",
      "your_booking_request_has_been_sent": "Votre demande de réservation a été envoyée.",
      "an_error_occurred_while_sending": "Une erreur est survenue lors de l’envoi.",
      "holiday_rental": "Location de vacances",
      "holidays": "Vacances",
      "night": "nuit",
      "guests": "voyageurs",
      "bedrooms_154": "chambres",
      "book": "Réserver",
      "call": "Appeler",
      "view_accommodation": "Voir le logement",
      "lina_immo_holidays": "Lina Immo Vacances",
      "booking_request": "Demande de réservation",
      "close": "Fermer",
      "night_161": "/ nuit",
      "check_in_date": "Date d’arrivée",
      "select": "Sélectionner",
      "check_out_date": "Date de départ",
      "guests_165": "Voyageurs",
      "name": "Nom",
      "message": "Message",
      "the_length_of_stay_discount_must_be_confirmed_before_booking": "La remise de durée de ce logement doit être confirmée avant réservation.",
      "tnd": "TND ×",
      "nights": "nuits",
      "discount_applied": "Réduction appliquée",
      "estimated_total": "Total estimé",
      "sending": "Envoi...",
      "send_request": "Envoyer la demande",
      "locate_your_property": "Localisez votre bien",
      "cost": "Coût",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "contact_details_179": "Contacts",
      "property_location": "Localisation du bien",
      "find_this_address": "Rechercher cette adresse",
      "postal_code_182": "Code Postal",
      "select_a_city_183": "Sélectionnez une ville",
      "select_a_district": "Sélectionnez une délégation",
      "view_conversations": "Voir les conversations",
      "your_conversation_starts_here": "La conversation commence ici",
      "ask_your_first_question_about_this_listing": "Posez votre première question sur cette annonce.",
      "this_listing_has_been_deleted_you_can_still_read_your_messages": "Cette annonce a été supprimée. Vous pouvez toujours consulter vos échanges.",
      "this_recipient_is_no_longer_available_you_can_still_read_your_messages": "Ce destinataire n’est plus disponible. Vous pouvez toujours consulter vos échanges.",
      "your_message": "Votre message",
      "write_your_message": "Écrivez votre message…",
      "send": "Envoyer",
      "enter_to_send_shift_enter_for_a_new_line": "Entrée pour envoyer · Maj + Entrée pour revenir à la ligne",
      "signed_in_with_google": "Connexion réussie avec Google !",
      "unable_to_sign_in_with_google": "Impossible de s'authentifier avec Google.",
      "continue_with_google": "Continuer avec Google",
      "signing_in_with_google": "Connexion…",
      "google_popup_blocked": "La fenêtre Google a été bloquée. Autorisez les fenêtres pop-up puis réessayez.",
      "google_network_error": "Connexion Internet indisponible. Réessayez.",
      "price": "Prix",
      "discounted_price": "Prix Réduit",
      "download_the_pdf_to_print": "Télécharger le PDF pour impression",
      "describe_your_property_202": "Décrivez votre bien",
      "title": "Titre",
      "description": "Description",
      "area_m": "Surface (m²)",
      "number_of_bedrooms": "Nombre de chambres",
      "number_of_bathrooms": "Nombre de salles de bain",
      "furnished": "Meublé",
      "tnd_209": "Dt /",
      "total_price": "Prix total:",
      "host_211": "Hôte:",
      "rating": "Note:",
      "reviews": "avis)",
      "in_dinars": "en Dinars",
      "loading": "Chargement...",
      "no_properties_available": "Aucun bien disponible",
      "month_217": "/ Mois",
      "loading_218": "Chargement…",
      "no_vacation_rentals_available_at_the_moment": "Aucune location de vacances disponible pour le moment.",
      "loading_220": "Chargement...",
      "user_account": "Compte utilisateur",
      "my_account": "Mon espace personnel",
      "sign_in": "Se connecter",
      "create_an_account": "Créer un compte",
      "offer": "Offre",
      "sign_in_to_use_favorites": "Connectez-vous pour utiliser les favoris.",
      "refresh_your_favorites_before_trying_again": "Actualisez les favoris avant de réessayer.",
      "unable_to_load_requests": "Impossible de charger les demandes.",
      "expired": "Expirée",
      "pending": "En attente",
      "confirmed": "Confirmée",
      "rejected": "Rejetée",
      "cancelled": "Annulée",
      "invalid_request_id": "Identifiant de demande invalide.",
      "unable_to_update_the_request": "Impossible de mettre à jour la demande.",
      "request_accepted": "Demande acceptée.",
      "are_you_sure_you_want_to_reject_this_request": "Êtes-vous sûr de vouloir rejeter cette demande ?",
      "request_rejected": "Demande rejetée.",
      "booking_requests": "Demandes de réservation",
      "view_incoming_requests_and_accept_or_reject_bookings": "Consultez les demandes reçues et acceptez ou rejetez les réservations.",
      "confirmed_242": "Confirmées",
      "rejected_243": "Rejetées",
      "expired_244": "Expirées",
      "error": "Erreur",
      "accommodation": "Logement",
      "request_date": "Date de demande",
      "check_in": "Arrivée",
      "check_out": "Départ",
      "accept": "Accepter",
      "reject": "Rejeter",
      "request": "Demande",
      "status": "Statut",
      "actions": "Actions",
      "no_requests": "Aucune demande",
      "you_have_no_booking_requests_to_review_at_the_moment": "Vous n'avez aucune demande de réservation à traiter pour le moment.",
      "unable_to_load_your_bookings": "Impossible de charger vos réservations.",
      "are_you_sure_you_want_to_cancel_this_booking": "Êtes-vous sûr de vouloir annuler cette réservation ?",
      "booking_cancelled": "Réservation annulée.",
      "unable_to_cancel_the_booking": "Impossible d'annuler la réservation.",
      "my_bookings": "Mes réservations",
      "view_and_manage_all_your_booking_requests": "Retrouvez et gérez toutes vos demandes de réservation.",
      "cancelled_263": "Annulées",
      "booking": "Réservation",
      "cancel": "Annuler",
      "no_bookings": "Aucune réservation",
      "you_have_no_bookings_to_display_at_the_moment": "Vous n'avez aucune réservation à afficher pour le moment.",
      "error_268": "Erreur :",
      "text_search": "Recherche texte :",
      "listings_found": "Annonces trouvées",
      "continue_to_the_next_listings": "Continuer dans les annonces suivantes",
      "offers_found_in": "Offres trouvées à",
      "hide_conversations": "Masquer les conversations",
      "show_conversations": "Afficher les conversations",
      "no_conversations": "Aucune conversation",
      "listing": "Annonce",
      "write_your_message_277": "Écrivez votre message...",
      "select_a_conversation_to_get_started": "Sélectionnez une conversation pour commencer.",
      "unable_to_load_your_conversations": "Impossible de charger vos conversations.",
      "unable_to_load_this_conversation": "Impossible de charger cette conversation.",
      "unable_to_send_the_message": "Impossible d'envoyer le message.",
      "do_you_want_to_delete_this_conversation": "Voulez-vous supprimer cette conversation ?",
      "unable_to_delete_this_conversation": "Impossible de supprimer cette conversation.",
      "sign_in_required": "Connexion requise",
      "sign_in_to_view_your_conversations": "Connectez-vous pour consulter vos conversations.",
      "your_conversations_with_owners_and_users_will_appear_here": "Vos échanges avec les propriétaires et les utilisateurs apparaîtront ici.",
      "select_a_conversation_287": "Sélectionnez une conversation",
      "choose_a_conversation_to_view_its_messages": "Choisissez une conversation pour afficher les messages.",
      "type": "Type",
      "photos_290": "Photos",
      "select_the_transaction_and_property_type": "Sélectionnez le type de transaction et la catégorie.",
      "a_listing_title_is_required": "Le titre de l’annonce est obligatoire.",
      "enter_a_valid_area": "Veuillez indiquer une surface valide.",
      "enter_the_property_address": "Veuillez renseigner l’adresse du bien.",
      "enter_a_valid_price": "Veuillez saisir un prix valide.",
      "the_discounted_price_must_be_below_the_original_price": "Le prix réduit doit être inférieur au prix initial.",
      "enter_your_email_and_phone_number": "Veuillez renseigner votre e-mail et votre téléphone.",
      "you_must_be_signed_in_to_post_a_listing": "Vous devez être connecté pour publier une annonce.",
      "add_at_least_one_photo": "Ajoutez au moins une photo.",
      "your_listing_has_been_published_successfully": "Votre annonce a été publiée avec succès.",
      "unable_to_publish_the_listing": "Impossible de publier l’annonce.",
      "enter_your_property_details_in_a_few_steps": "Renseignez les informations de votre bien en quelques étapes.",
      "what_type_of_listing_would_you_like_to_post": "Quel type d’annonce souhaitez-vous publier ?",
      "choose_the_transaction_and_property_type": "Choisissez la transaction et le type de propriété.",
      "sale_or_rental": "Vente ou location",
      "sell": "Vendre",
      "rent_308": "Louer",
      "property_type": "Type de bien",
      "add_a_clear_title_and_the_main_features": "Ajoutez un titre clair et les caractéristiques essentielles.",
      "listing_title": "Titre de l’annonce",
      "e_g_bright_apartment_in_tunis": "Ex. Appartement lumineux à Tunis",
      "describe_the_highlights_of_your_property": "Décrivez les points forts de votre bien...",
      "enter_the_exact_address_so_buyers_can_easily_locate_your_property": "Indiquez l'adresse exacte afin que les acheteurs puissent facilement situer votre bien.",
      "set_the_price": "Définissez le prix",
      "enter_the_property_price_and_optionally_add_a_discount": "Indiquez le prix du bien et ajoutez éventuellement une promotion.",
      "special_offer": "Offre promotionnelle",
      "discounted_price_318": "Prix réduit",
      "your_contact_details": "Vos coordonnées",
      "these_details_will_allow_interested_people_to_contact_you": "Ces informations permettront aux intéressés de vous contacter.",
      "add_your_photos": "Ajoutez vos photos",
      "add_bright_clear_photos_to_showcase_your_property": "Ajoutez des photos lumineuses et nettes pour mettre votre bien en valeur.",
      "publishing": "Publication...",
      "publish_listing": "Publier l’annonce",
      "address_not_found_325": "Adresse introuvable",
      "listing_published": "Annonce publiée.",
      "amenities": "Équipements",
      "capacity": "Capacité",
      "rates": "Tarifs",
      "select_an_accommodation_type": "Sélectionnez un type de logement.",
      "the_accommodation_must_host_at_least_one_person": "Le logement doit accueillir au moins une personne.",
      "enter_a_valid_price_332": "Veuillez renseigner un prix valide.",
      "the_discounted_price_must_be_below_the_regular_price": "Le prix réduit doit être inférieur au prix normal.",
      "enter_your_email_and_phone_number_334": "Renseignez votre e-mail et votre téléphone.",
      "your_vacation_rental_has_been_published": "Votre location de vacances a été publiée.",
      "unable_to_publish_your_listing": "Impossible de publier votre annonce.",
      "present_your_accommodation_amenities_and_rates_in_a_few_steps": "Présentez votre logement, ses équipements et ses tarifs en quelques étapes.",
      "what_type_of_accommodation_do_you_offer": "Quel type de logement proposez-vous ?",
      "select_the_option_that_matches_your_rental": "Sélectionnez la formule correspondant à votre location.",
      "amenities_and_services": "Équipements et services",
      "select_the_amenities_available_in_your_accommodation": "Sélectionnez les équipements disponibles dans votre logement.",
      "locate_the_accommodation": "Localisez le logement",
      "enter_the_address_and_check_the_location_on_the_map": "Indiquez l’adresse et vérifiez la position sur la carte.",
      "accommodation_capacity": "Capacité du logement",
      "enter_the_number_of_guests_bedrooms_beds_and_bathrooms": "Indiquez le nombre de voyageurs, chambres, lits et salles de bain.",
      "set_your_rates": "Définissez vos tarifs",
      "enter_the_daily_rate_and_any_discounts": "Indiquez le tarif journalier et vos réductions éventuelles.",
      "price_per_night": "Prix par nuit",
      "weekly_discount": "Réduction hebdomadaire",
      "for_a_one_week_stay": "Pour un séjour d’une semaine",
      "monthly_discount": "Réduction mensuelle",
      "for_a_one_month_stay": "Pour un séjour d’un mois",
      "these_details_will_allow_guests_to_contact_you": "Ces informations permettront aux voyageurs de vous contacter.",
      "add_accommodation_photos": "Ajoutez les photos du logement",
      "choose_bright_photos_that_show_the_rooms_and_amenities": "Choisissez des photos lumineuses qui présentent les pièces et les équipements.",
      "publish_rental": "Publier la location",
      "wi_fi": "Wi-Fi",
      "dedicated_workspace": "Espace de travail dédié",
      "free_on_site_parking": "Parking gratuit sur place",
      "private_indoor_pool": "Piscine intérieure privée",
      "tv": "TV",
      "security_cameras": "Caméras de surveillance",
      "barbecue": "Barbecue",
      "beach_access": "Accès plage",
      "air_conditioning": "Climatisation",
      "check_in_cannot_be_after_check_out": "La date d'arrivée ne peut pas être après la date de départ.",
      "sign_in_to_send_a_booking_request": "Veuillez vous connecter pour envoyer une réservation.",
      "your_message_has_been_sent_successfully": "Votre message a été envoyé avec succès.",
      "error_369": "Erreur :",
      "apartment_information": "Informations sur l'appartement",
      "guest_s": "voyageur(s)",
      "bedroom_s": "chambre(s) ·",
      "bed_s": "lit(s)",
      "bathroom_s": "salle(s) de bain",
      "phone_number": "Numéro de téléphone :",
      "event_form": "Formulaire d'événement",
      "title_377": "Civilité *",
      "first_name": "Prénom *",
      "last_name": "Nom *",
      "event_type": "Type d'événements",
      "one_hour_marriage_ceremony": "Contrat de Mariage 1 heure",
      "birthday": "Anniversaire",
      "other": "Autre",
      "mobile_phone": "Téléphone Mobile *",
      "email_385": "E-mail *",
      "event_date": "Date d'événement *",
      "start_time": "Heure de début",
      "end_time": "Heure de fin",
      "number_of_guests": "Nombre d'invités *",
      "unable_to_load_this_rental": "Impossible de charger cette location.",
      "a_network_error_occurred": "Une erreur réseau est survenue.",
      "unable_to_load_this_rental_392": "Impossible de charger cette location",
      "this_rental_could_not_be_found": "Cette location est introuvable.",
      "vacation_rental": "Location vacances",
      "tnd_395": "TND /",
      "beds_396": "lits",
      "no_amenities_specified": "Aucun équipement renseigné.",
      "per_night": "par nuit",
      "discount": "Réduction",
      "guest_s_400": "voyageur(s) ·",
      "bed_s_401": "lit(s) ·",
      "1_guest": "1 voyageur",
      "2_guests": "2 voyageurs",
      "3_guests": "3 voyageurs",
      "4_guests": "4 voyageurs",
      "5_guests": "5 voyageurs",
      "6_guests": "6 voyageurs",
      "7_guests": "7 voyageurs",
      "8_guests": "8 voyageurs",
      "tnd_410": "dt x",
      "weekly_discount_411": "Réduction à la semaine",
      "tnd_412": "dt )",
      "monthly_discount_413": "Réduction au mois",
      "tnd_414": "dt)",
      "total": "Total",
      "by_email": "Par email :",
      "or": "OU",
      "call_418": "Appelez :",
      "property": "Bien",
      "information": "Informations",
      "invalid_listing_id": "Identifiant de l'annonce invalide.",
      "you_do_not_own_this_listing": "Vous n’êtes pas propriétaire de cette annonce.",
      "this_listing_could_not_be_found": "Cette annonce est introuvable.",
      "unable_to_retrieve_this_listing_s_information": "Impossible de récupérer les informations de cette annonce.",
      "no_changes_detected": "Aucune modification détectée.",
      "the_listing_has_been_updated": "L'annonce a été mise à jour.",
      "unable_to_update_the_listing": "Impossible de mettre à jour l'annonce.",
      "unable_to_edit_the_listing": "Impossible de modifier l'annonce",
      "back_to_my_listings": "Retour à mes annonces",
      "edit_listing": "Modifier l'annonce",
      "edit_your_listing_details_then_save_your_changes": "Modifiez les informations de votre annonce puis enregistrez vos changements.",
      "unsaved_changes": "Modifications non enregistrées",
      "step_1": "Étape 1",
      "property_information": "Informations du bien",
      "edit_the_main_details_of_your_listing": "Modifiez les informations principales de votre annonce.",
      "step_2": "Étape 2",
      "additional_information": "Informations supplémentaires",
      "complete_the_property_s_features_and_additional_details": "Complétez les caractéristiques et les informations complémentaires du bien.",
      "step_3": "Étape 3",
      "listing_photos": "Photos de l'annonce",
      "keep_remove_or_add_photos_to_your_listing": "Conservez, supprimez ou ajoutez des photos à votre annonce.",
      "manage_photos": "Gérer les photos",
      "existing_photos_are_kept_unless_you_delete_them_you_can_also_add_new_ones": "Les photos existantes sont conservées sauf si vous les supprimez. Vous pouvez également en ajouter de nouvelles.",
      "updating": "Mise à jour...",
      "update_listing": "Mettre à jour l'annonce",
      "bathrooms_446": "Salles de bain",
      "unable_to_retrieve_this_rental_s_information": "Impossible de récupérer les informations de cette location.",
      "the_rental_has_been_updated": "La location a été mise à jour.",
      "unable_to_update_the_rental": "Impossible de mettre à jour la location.",
      "unable_to_edit_this_rental": "Impossible de modifier cette location",
      "edit_rental": "Modifier la location",
      "edit_your_accommodation_amenities_details_and_photos": "Modifiez votre logement, ses équipements, ses informations et ses photos.",
      "accommodation_information": "Informations du logement",
      "edit_the_main_details_of_your_vacation_rental": "Modifiez les informations principales de votre location de vacances.",
      "edit_the_accommodation_s_capacity_rates_and_additional_details": "Modifiez la capacité, les tarifs et les informations complémentaires du logement.",
      "specify_the_amenities_available_to_guests": "Indiquez les équipements disponibles pour les voyageurs.",
      "accommodation_photos": "Photos du logement",
      "keep_remove_or_add_photos_to_your_rental": "Conservez, supprimez ou ajoutez des photos à votre location.",
      "keep_your_existing_photos_or_add_new_ones_to_showcase_your_accommodation": "Gardez vos photos existantes ou ajoutez de nouvelles images pour mieux présenter votre logement.",
      "update_rental": "Mettre à jour la location",
      "my_activity": "Mon activité",
      "sign_in_to_view_your_activity": "Connectez-vous pour retrouver votre activité.",
      "nothing_here_yet": "Aucun élément pour le moment.",
      "clear_history": "Vider l’historique",
      "search_again": "— Relancer",
      "buy": "Acheter",
      "houses_apartments": "Maisons & appartements",
      "apartments_houses": "Appartements & maisons",
      "villas_residences": "Villas & résidences",
      "offices": "Bureaux",
      "business_spaces": "Espaces professionnels",
      "shops": "Commerces",
      "premises_businesses": "Locaux & fonds",
      "land": "Terrains",
      "land_for_sale": "Terrains à vendre",
      "available_properties": "Biens disponibles",
      "satisfied_customers": "Clients satisfaits",
      "governorates_covered": "Gouvernorats couverts",
      "average_rating": "Note moyenne",
      "verified_listings": "Annonces vérifiées",
      "all_listings_are_manually_reviewed": "Toutes les annonces sont contrôlées manuellement.",
      "secure_payment": "Paiement sécurisé",
      "your_transactions_are_protected_and_secure": "Vos transactions sont protégées et sécurisées.",
      "support_7_days_a_week": "Assistance 7j/7",
      "our_team_is_available_to_help_you": "Notre équipe reste disponible pour vous accompagner.",
      "certified_agents": "Agents certifiés",
      "real_estate_professionals_at_your_service": "Des professionnels de l'immobilier à votre service.",
      "i_found_my_apartment_in_just_two_days_fast_and_efficient_service": "J'ai trouvé mon appartement en seulement deux jours. Service rapide et efficace !",
      "the_site_is_very_easy_to_use_and_the_listings_are_high_quality": "Le site est très simple à utiliser et les annonces sont de bonne qualité.",
      "thanks_to_the_lina_immo_team_for_their_professionalism_and_attentiveness": "Merci à l'équipe Lina Immo pour son professionnalisme et son écoute.",
      "unable_to_load_listings": "Impossible de charger les annonces.",
      "houses_for_sale_rentals_and_villas_in_tunisia_lina_immo": "Maison à vendre, location et villa en Tunisie | Lina Immo",
      "explore_lina_immo_listings_houses_for_sale_apartments_for_rent_villas_land_and_vacation_rentals_in_t": "Découvrez les annonces immobilières Lina Immo : maisons à vendre, appartements à louer, villas, terrains et locations de vacances en Tunisie.",
      "tunisia_real_estate_house_for_sale_apartment_for_rent_villa_for_sale_land_vacation_rental_tunis_sfax": "immobilier Tunisie, maison à vendre, appartement à louer, villa à vendre, terrain, location vacances, Tunis, Sfax, Sousse, Hammamet",
      "your_real_estate_partner_in_tunisia": "Votre partenaire immobilier en Tunisie",
      "find_your_next_home": "Trouvez votre futur logement",
      "buy_rent_or_book_the_property_that_meets_your_needs_anywhere_in_tunisia": "Achetez, louez ou réservez le bien qui correspond à vos besoins partout en Tunisie.",
      "governorate": "Gouvernorat",
      "all_governorates": "Tous les gouvernorats",
      "all_districts": "Toutes les délégations",
      "all_types": "Tous les types",
      "apartment": "Appartement",
      "house": "Maison",
      "villa": "Villa",
      "office": "Bureau",
      "shop": "Commerce",
      "land_508": "Terrain",
      "maximum_price": "Prix maximum",
      "all_budgets": "Tous les budgets",
      "searching": "Recherche...",
      "search": "Rechercher",
      "over_12_000_listings_available": "Plus de 12 000 annonces disponibles",
      "explore_by_category": "Explorer par catégorie",
      "why_choose_lina_immo": "Pourquoi choisir Lina Immo ?",
      "our_popular_cities": "Nos villes populaires",
      "they_trust_us": "Ils nous font confiance",
      "mobile_app": "Application mobile",
      "take_lina_immo_everywhere": "Emportez Lina Immo partout avec vous",
      "find_your_favorite_listings_contact_owners_and_post_properties_from_your_phone": "Retrouvez vos annonces favorites, contactez les propriétaires et publiez vos biens depuis votre téléphone.",
      "available_on_google_play": "▶ Disponible sur Google Play",
      "android_pending_validation": "Bientôt sur Google Play.",
      "ios_coming_soon": "Bientôt disponible.",
      "download_on_the_app_store": " Télécharger sur l'App Store",
      "stay_informed": "Restez informé",
      "receive_new_listings_and_real_estate_offers_directly_by_email": "Recevez les nouvelles annonces et les bons plans immobiliers directement par e-mail.",
      "your_email_address": "Votre adresse e-mail",
      "unable_to_load_this_listing": "Impossible de charger cette annonce.",
      "please_complete_all_fields": "Veuillez compléter tous les champs.",
      "unable_to_load_the_listing": "Impossible de charger l’annonce",
      "link_copied": "Lien copié",
      "special_offer_530": "Offre spéciale",
      "save": "Économisez",
      "no_parking": "Sans parking",
      "unfurnished": "Non meublé",
      "no_description_available": "Aucune description disponible.",
      "location": "Localisation",
      "open_in_maps": "Ouvrir dans Maps",
      "contact_the_owner": "Contacter l’annonceur",
      "get_more_information_or_arrange_a_viewing_of_this_property": "Obtenez plus d’informations ou organisez une visite de ce bien.",
      "your_message_has_been_sent": "Votre message a bien été envoyé.",
      "send_a_message": "Envoyer un message",
      "your_name": "Votre nom",
      "send_message": "Envoyer le message",
      "you_own_this_listing": "Vous êtes le propriétaire de cette annonce.",
      "no_photos_available": "Aucune photo disponible",
      "view": "Voir les",
      "share_listing": "Partager l'annonce",
      "photo_gallery": "Galerie photos",
      "close_gallery": "Fermer la galerie",
      "empty_message": "[Message vide]",
      "offers_found": "Offres trouvées",
      "no_exact_matches": "Aucune correspondance exacte",
      "change_or_remove_some_filters_or_adjust_your_search_area": "Modifiez ou supprimez certains de vos filtres ou ajustez votre zone de recherche.",
      "date": "Date",
      "unable_to_sign_out": "Impossible de vous déconnecter.",
      "the_name_cannot_be_empty": "Le nom ne peut pas être vide.",
      "profile_updated": "Profil mis à jour.",
      "unable_to_update_your_profile": "Impossible de mettre à jour votre profil.",
      "you_can_tell_us_why_you_are_leaving": "Vous pouvez indiquer la raison de votre départ.",
      "this_action_is_permanent_are_you_sure_you_want_to_delete_your_account": "Cette action est définitive. Voulez-vous vraiment supprimer votre compte ?",
      "your_account_has_been_deleted": "Votre compte a été supprimé.",
      "for_security_sign_in_again_before_deleting_your_account": "Pour des raisons de sécurité, reconnectez-vous avant de supprimer votre compte.",
      "unable_to_delete_your_account": "Impossible de supprimer votre compte.",
      "my_profile": "Mon profil",
      "manage_your_personal_information_and_account_settings": "Gérez vos informations personnelles et les paramètres de votre compte.",
      "your_email_address_is_linked_to_your_sign_in_account": "L’adresse e-mail est liée à votre compte de connexion.",
      "save_567": "Enregistrer",
      "session": "Session",
      "you_can_sign_out_of_your_account_at_any_time": "Vous pouvez vous déconnecter de votre compte à tout moment.",
      "sign_out": "Se déconnecter",
      "danger_zone": "Zone sensible",
      "deleting_your_account_is_permanent_and_cannot_be_undone": "La suppression de votre compte est définitive et ne peut pas être annulée.",
      "delete_my_account": "Supprimer mon compte",
      "confirm_deletion": "Confirmer la suppression",
      "you_can_tell_us_why_you_want_to_delete_your_account": "Vous pouvez nous indiquer pourquoi vous souhaitez supprimer votre compte.",
      "reason_for_deletion_optional": "Raison de la suppression (facultatif)",
      "deleting": "Suppression...",
      "delete_permanently": "Supprimer définitivement",
      "cancel_this_booking_request": "Annuler cette demande de réservation ?",
      "my_booking": "Ma réservation",
      "loading_581": "Chargement…",
      "no_bookings_available": "Aucune réservation disponible.",
      "guests_583": "voyageurs ·",
      "accepted": "Acceptée",
      "rejected_585": "Rejetée",
      "unknown_status": "Statut inconnu",
      "listing_deleted_587": "Annonce supprimée",
      "cancel_request": "Annuler la demande",
      "studio": "Studio",
      "2_rooms": "2 pièces",
      "3_rooms": "3 pièces",
      "4_rooms": "4 pièces",
      "5_rooms": "5 pièces",
      "6_or_more_rooms": "6 pièces et plus",
      "property_search": "Recherche immobilière",
      "select_a_city_then_refine_your_search_criteria": "Sélectionnez une ville puis affinez votre recherche selon vos critères.",
      "all_cities": "Voir toutes les villes",
      "category": "Catégorie",
      "all_categories": "Voir toutes les catégories",
      "commercial": "Commercial",
      "other_601": "Autres",
      "hide_filters": "Masquer les filtres",
      "advanced_search": "Recherche avancée",
      "keyword": "Mot-clé",
      "apartment_villa_land": "Appartement, villa, terrain...",
      "number_of_rooms": "Nombre de pièces",
      "minimum_price": "Prix minimum",
      "reset": "Réinitialiser",
      "at_least_6_characters": "6 caractères minimum",
      "passwords_do_not_match": "Les mots de passe ne correspondent pas",
      "a_verification_email_has_been_sent_please_verify_your_email_before_continuing": "Un email de vérification vous a été envoyé. Veuillez vérifier avant de continuer.",
      "email_verified": "Email vérifié !",
      "invalid_email": "Email invalide",
      "email_already_in_use": "Email déjà utilisé",
      "registration_failed": "Erreur d'inscription",
      "illustration": "illustration",
      "unable_to_load_vacation_rentals": "Impossible de charger les locations de vacances.",
      "find_your_vacation_rental": "Trouvez votre location de vacances",
      "discover_accommodation_across_tunisia_for_your_holidays_and_short_stays": "Découvrez des logements disponibles partout en Tunisie pour vos vacances et courts séjours.",
      "title_or_location": "Titre ou localisation",
      "destination": "Destination",
      "number": "Nombre",
      "available_stays": "Séjours disponibles",
      "rentals_in_city": "Locations à {{city}}",
      "all_rentals": "Voir toutes les locations",
      "show_more": "Voir plus",
      "no_rentals_found": "Aucune location trouvée",
      "change_your_destination_or_number_of_guests_to_find_more_accommodation": "Modifiez votre destination ou le nombre de voyageurs pour découvrir plus de logements.",
      "reset_filters": "Réinitialiser les filtres",
      "sign_in_to_continue": "Veuillez vous connecter pour continuer.",
      "your_session_has_changed_sign_in_again": "La session a changé. Reconnectez-vous.",
      "invalid_request_check_the_information_entered": "La demande est invalide. Vérifiez les informations saisies.",
      "your_session_is_invalid_or_expired_sign_in_again": "Votre session est invalide ou expirée. Veuillez vous reconnecter.",
      "you_are_not_allowed_to_perform_this_action": "Vous n'êtes pas autorisé à effectuer cette action.",
      "this_resource_could_not_be_found_or_has_been_deleted": "Cette ressource est introuvable ou a été supprimée.",
      "this_action_conflicts_with_the_current_data_refresh_and_try_again": "Cette action entre en conflit avec les données actuelles. Actualisez puis réessayez.",
      "this_listing_has_been_deleted": "Cette annonce a été supprimée.",
      "api_url_not_allowed": "URL API non autorisée.",
      "unable_to_connect_check_your_connection_and_try_again": "Connexion impossible. Vérifiez votre connexion et réessayez.",
      "add_photos_to_the_listing_form_before_saving": "Ajoutez les photos au formulaire de l'annonce avant de l'enregistrer.",
      "missing_listing_id": "Identifiant de l'annonce manquant.",
      "this_listing_is_no_longer_available": "Cette annonce n'est plus disponible.",
      "you_do_not_own_this_listing_643": "Vous n'êtes pas propriétaire de cette annonce.",
      "this_conversation_is_not_accessible": "Cette conversation n'est pas accessible.",
      "invalid_recipient_or_message": "Destinataire ou message invalide.",
      "this_conversation_no_longer_accepts_new_messages": "Cette conversation ne permet plus de nouveaux messages.",
      "unable_to_upload_files": "Impossible de téléverser les fichiers.",
      "invalid_listing": "Annonce invalide.",
      "the_server_did_not_return_a_pdf": "Le serveur n'a pas retourné un PDF.",
      "invalid_date": "Date invalide.",
      "choose_a_check_in_date_from_today_and_a_check_out_date_after_check_in": "Choisissez une arrivée à partir d'aujourd'hui et un départ après l'arrivée.",
      "invalid_number_of_guests": "Nombre de voyageurs invalide.",
      "a_request_is_already_in_progress": "Une demande est déjà en cours.",
      "you_cannot_book_your_own_accommodation": "Vous ne pouvez pas réserver votre propre logement.",
      "the_number_of_guests_exceeds_the_accommodation_s_capacity": "Le nombre de voyageurs dépasse la capacité du logement.",
      "the_length_of_stay_discount_must_be_confirmed_before_booking_656": "La remise de durée de ce logement doit être confirmée avant réservation.",
      "these_dates_are_no_longer_available": "Ces dates ne sont plus disponibles.",
      "this_booking_does_not_belong_to_you": "Cette réservation ne vous appartient pas.",
      "only_a_pending_request_can_be_cancelled": "Seule une demande en attente peut être annulée.",
      "you_do_not_own_this_booking": "Vous n'êtes pas le propriétaire de cette réservation.",
      "this_request_has_already_been_processed": "Cette demande a déjà été traitée.",
      "this_request_can_no_longer_be_accepted_the_account_or_listing_was_deleted": "Cette demande ne peut plus être acceptée : compte ou annonce supprimé.",
      "unable_to_load_properties": "Impossible de charger les biens.",
      "server_unavailable": "Le serveur est momentanément indisponible. Réessayez plus tard.",
      "select_departure": "Sélectionnez la date de départ",
      "select_arrival": "Sélectionnez la date d'arrivée",
      "google_sign_in": "Se connecter avec Google",
      "newsletter_email_required": "Veuillez saisir votre adresse e-mail.",
      "newsletter_success": "Merci ! Votre inscription a bien été enregistrée.",
      "vacation_message": "Bonjour, je souhaite obtenir plus d’informations concernant cette location.",
      "property_message": "Bonjour, votre bien m'intéresse. Est-il toujours disponible ?",
      "pdf_failed": "Impossible de générer le PDF.",
      "invalid_conversation": "Paramètres manquants ou invalides pour la conversation.",
      "view_all": "Voir tout",
      "loading_failed": "Une erreur est survenue pendant le chargement.",
      "search_failed": "Impossible d'effectuer la recherche.",
      "featured_properties": "Biens à la une",
      "view_listings": "Voir les annonces",
      "all_sales": "Voir toutes les ventes",
      "all_listings": "Voir toutes les annonces",
      "share_failed": "Impossible de partager le lien.",
      "all_properties": "Tous les biens",
      "offers_only": "Offres uniquement",
      "recently_viewed": "Récemment consultées",
      "listing_brand": "Annonce LinaImmo",
      "property_count": "{{count}} biens",
      "published_count": "{{count}} annonces publiées",
      "image_number": "Photo {{number}}",
      "listing_image": "{{title}} — photo {{number}}",
      "main_image": "{{title}} — photo principale",
      "view_listing_named": "Voir l’annonce {{title}}",
      "account_name": "Compte de {{name}}",
      "increase": "Augmenter {{label}}",
      "decrease": "Diminuer {{label}}",
      "confirmed_total": "Total confirmé : {{total}} TND. ",
      "properties_in_city": "Immobilier à {{city}}",
      "min_budget": "Min. {{price}} TND",
      "max_budget": "Max. {{price}} TND",
      "room_filter": "Chambres : {{rooms}}",
      "guest_filter": "Voyageurs : {{guests}}",
      "offers_city": "Offres trouvées à {{city}}",
      "network_error_detail": "Erreur : {{message}}",
      "http_error": "Erreur HTTP : {{status}}",
      "photo_remove": "Supprimer la photo",
      "previous_month": "Mois précédent",
      "next_month": "Mois suivant",
      "clear_date": "Effacer la date",
      "recent_search_history": "Recherches récentes",
      "photos_total": "Voir les {{count}} photos",
      "error_prefix": "Erreur :"
    },
    "remove_from_favorites": "Retirer des favoris",
    "add_to_favorites": "Ajouter aux favoris",
    "saving": "Enregistrement...",
    "in_my_favorites": "Dans mes favoris",
    "share": "Partager",
    "messages": "Messages",
    "preparing": "Préparation...",
    "print": "Imprimer",
    "messages.search": "Rechercher une conversation",
    "messages.deleted_listing": "Annonce supprimée",
    "messages.property_discussion": "À propos de cette annonce",
    "messages.open_discussion": "Voir les échanges",
    "messages.delete_conversation": "Supprimer la conversation",
    "messages.no_results": "Aucune conversation trouvée",
    "messages.discussion_note": "Tous vos échanges, au même endroit.",
    "create": {
      "address_search_required": "Veuillez saisir une adresse.",
      "address_not_found": "Adresse introuvable.",
      "address_search_error": "Impossible de rechercher cette adresse pour le moment.",
      "address_fields_required": "Veuillez renseigner la ville et la délégation.",
      "position_unconfirmed": "Position non confirmée",
      "area_position": "Position approximative de la délégation, pas de l’adresse exacte.",
      "search_address": "Rechercher l’adresse",
      "map_preview": "Aperçu sur la carte",
      "step_6": "Étape 6",
      "photos_title": "Ajoutez vos photos",
      "photos_description": "Ajoutez des photos lumineuses et nettes pour mettre votre bien en valeur.",
      "upload_photos": "Importer vos photos",
      "upload_photos_help": "Choisissez une belle photo principale puis ajoutez les différentes pièces et les équipements.",
      "photo_tips_title": "Conseils",
      "photo_tips": "Utilisez des photos horizontales, nettes et lumineuses. Évitez les images floues ou trop sombres.",
      "select_type_error": "Sélectionnez le type de transaction et la catégorie.",
      "title_required": "Le titre de l’annonce est obligatoire.",
      "surface_required": "Veuillez indiquer une surface valide.",
      "address_required": "Veuillez renseigner l’adresse du bien.",
      "price_required": "Veuillez saisir un prix valide.",
      "discount_price_error": "Le prix réduit doit être inférieur au prix initial.",
      "contact_required": "Veuillez renseigner votre e-mail et votre téléphone.",
      "login_required": "Vous devez être connecté pour publier une annonce.",
      "images_required": "Ajoutez au moins une photo.",
      "success": "Votre annonce a été publiée avec succès.",
      "error": "Impossible de publier l’annonce.",
      "description": "Renseignez les informations de votre bien en quelques étapes.",
      "transaction_title": "Quel type d’annonce souhaitez-vous publier ?",
      "transaction_description": "Choisissez la transaction et le type de propriété.",
      "describe_title": "Décrivez votre bien",
      "describe_description": "Ajoutez un titre clair et les caractéristiques essentielles.",
      "address_title": "Localisez votre bien",
      "address_description": "Indiquez l'adresse exacte afin que les acheteurs puissent facilement situer votre bien.",
      "price_title": "Définissez le prix",
      "price_description": "Indiquez le prix du bien et ajoutez éventuellement une promotion.",
      "discount_price": "Prix réduit",
      "contact_title": "Vos coordonnées",
      "contact_description": "Ces informations permettront aux intéressés de vous contacter.",
      "publish": "Publier l’annonce"
    },
    "SelectDelegation": "Sélectionner une délégation",
    "Continuer": "Continuer",
    "vacation": {
      "accommodation": "Location de vacances",
      "no_listings": "Aucune location de vacances disponible pour le moment.",
      "category_required": "Sélectionnez un type de logement.",
      "address_required": "Veuillez renseigner l’adresse, la ville et la délégation.",
      "guests_required": "Le logement doit accueillir au moins une personne.",
      "price_required": "Veuillez renseigner un prix valide.",
      "discount_error": "Le prix réduit doit être inférieur au prix normal.",
      "contact_required": "Renseignez votre e-mail et votre téléphone.",
      "login_required": "Vous devez être connecté pour publier une annonce.",
      "photos_required": "Ajoutez au moins une photo.",
      "create_success": "Votre location de vacances a été publiée.",
      "create_error": "Impossible de publier votre annonce.",
      "create_title": "Publier une location de vacances",
      "create_description": "Présentez votre logement, ses équipements et ses tarifs en quelques étapes.",
      "accommodation_title": "Quel type de logement proposez-vous ?",
      "accommodation_description": "Sélectionnez la formule correspondant à votre location.",
      "equipment_description": "Sélectionnez les équipements disponibles dans votre logement.",
      "address_title": "Localisez le logement",
      "address_description": "Indiquez l’adresse et vérifiez la position sur la carte.",
      "capacity_description": "Indiquez le nombre de voyageurs, chambres, lits et salles de bain.",
      "pricing_title": "Définissez vos tarifs",
      "pricing_description": "Indiquez le tarif journalier et vos réductions éventuelles.",
      "discount_price": "Prix réduit",
      "contact_description": "Ces informations permettront aux voyageurs de vous contacter.",
      "photos_title": "Ajoutez les photos du logement",
      "photos_description": "Choisissez des photos lumineuses qui présentent les pièces et les équipements.",
      "publish": "Publier la location",
      "search_description": "Découvrez des logements disponibles partout en Tunisie pour vos vacances et courts séjours.",
      "guests_placeholder": "Nombre",
      "available_stays": "Séjours disponibles",
      "results_in_city": "Locations à {{city}}",
      "all_results": "Toutes les locations",
      "results": "résultats",
      "result": "résultat"
    },
    "close": "Fermer",
    "messages.view_conversations": "Voir les conversations",
    "messages.title": "Messages",
    "messages.start": "La conversation commence ici",
    "messages.start_hint": "Posez votre première question sur cette annonce.",
    "messages.deleted_notice": "Cette annonce a été supprimée. Vous pouvez toujours consulter vos échanges.",
    "messages.recipient_unavailable": "Ce destinataire n’est plus disponible. Vous pouvez toujours consulter vos échanges.",
    "messages.keyboard_hint": "Entrée pour envoyer · Maj + Entrée pour revenir à la ligne",
    "messages.waiting_for_reply": "En attente de réponse : vous pourrez écrire de nouveau dès que votre interlocuteur aura répondu.",
    "messages.limit_consecutive": "Vous avez déjà envoyé plusieurs messages sans réponse. Attendez la réponse de votre interlocuteur avant d'écrire de nouveau.",
    "messages.limit_new_conversations": "Vous avez ouvert beaucoup de nouvelles conversations aujourd'hui. Vous pouvez toujours répondre dans vos conversations ; réessayez plus tard pour en ouvrir une nouvelle.",
    "loading": "Chargement...",
    "request": {
      "load_error": "Impossible de charger les demandes.",
      "invalid_id": "Identifiant de demande invalide.",
      "update_error": "Impossible de mettre à jour la demande.",
      "description": "Consultez les demandes reçues et acceptez ou rejetez les réservations.",
      "empty_description": "Vous n'avez aucune demande de réservation à traiter pour le moment."
    },
    "cancelled": "Annulées",
    "request_accepted": "Demande acceptée.",
    "request_cancelled": "Demande rejetée.",
    "refresh": "Actualiser",
    "accept": "Accepter",
    "reject": "Rejeter",
    "reservation": {
      "load_error": "Impossible de charger vos réservations.",
      "description": "Retrouvez et gérez toutes vos demandes de réservation.",
      "empty_description": "Vous n'avez aucune réservation à afficher pour le moment."
    },
    "confirm": "Êtes-vous sûr de vouloir annuler cette réservation ?",
    "success": "Réservation annulée.",
    "failed": "Impossible d'annuler la réservation.",
    "booking_date": "Réservation",
    "messages.load_error": "Impossible de charger vos conversations.",
    "messages.conversation_error": "Impossible de charger cette conversation.",
    "messages.send_error": "Impossible d'envoyer le message.",
    "messages.delete_confirm": "Voulez-vous supprimer cette conversation ?",
    "messages.delete_error": "Impossible de supprimer cette conversation.",
    "messages.login_required": "Connexion requise",
    "messages.login_description": "Connectez-vous pour consulter vos conversations.",
    "messages.empty_description": "Vos échanges avec les propriétaires et les utilisateurs apparaîtront ici.",
    "messages.select_conversation": "Sélectionnez une conversation",
    "messages.select_description": "Choisissez une conversation pour afficher les messages.",
    "rooms.bedrooms": "Chambres",
    "sending": "Envoi...",
    "details": "Capacité du logement",
    "edit.invalid_id": "Identifiant de l'annonce invalide.",
    "edit.not_found": "Cette annonce est introuvable.",
    "edit.load_error": "Impossible de récupérer les informations de cette annonce.",
    "edit.no_changes": "Aucune modification détectée.",
    "edit.success": "L'annonce a été mise à jour.",
    "edit.update_error": "Impossible de mettre à jour l'annonce.",
    "edit.error_title": "Impossible de modifier l'annonce",
    "edit.back_ads": "Retour à mes annonces",
    "edit.description": "Modifiez les informations de votre annonce puis enregistrez vos changements.",
    "edit.unsaved_changes": "Modifications non enregistrées",
    "edit.step": "Étape {{number}}",
    "edit.property_title": "Informations du bien",
    "edit.property_description": "Modifiez les informations principales de votre annonce.",
    "edit.additional_title": "Informations supplémentaires",
    "edit.additional_description": "Complétez les caractéristiques et les informations complémentaires du bien.",
    "edit.photos_title": "Photos de l'annonce",
    "edit.photos_description": "Conservez, supprimez ou ajoutez des photos à votre annonce.",
    "edit.manage_photos": "Gérer les photos",
    "edit.manage_photos_description": "Les photos existantes sont conservées sauf si vous les supprimez. Vous pouvez également en ajouter de nouvelles.",
    "edit.updating": "Mise à jour...",
    "editVacation": {
      "load_error": "Impossible de récupérer les informations de cette location.",
      "success": "La location a été mise à jour.",
      "update_error": "Impossible de mettre à jour la location.",
      "error_title": "Impossible de modifier cette location",
      "description": "Modifiez votre logement, ses équipements, ses informations et ses photos.",
      "property_title": "Informations du logement",
      "property_description": "Modifiez les informations principales de votre location de vacances.",
      "additional_title": "Informations supplémentaires",
      "additional_description": "Modifiez la capacité, les tarifs et les informations complémentaires du logement.",
      "options_title": "Équipements et services",
      "options_description": "Indiquez les équipements disponibles pour les voyageurs.",
      "photos_title": "Photos du logement",
      "photos_description": "Conservez, supprimez ou ajoutez des photos à votre location.",
      "manage_photos_description": "Gardez vos photos existantes ou ajoutez de nouvelles images pour mieux présenter votre logement."
    },
    "rooms.studio": "Studio",
    "rooms.two": "2 pièces",
    "rooms.three": "3 pièces",
    "rooms.four": "4 pièces",
    "rooms.five": "5 pièces",
    "rooms.six_or_more": "6 pièces et plus",
    "errorFetchingVacations": "Impossible de charger les locations de vacances.",
    "Conversations": "Conversations",
    "Profile": {
      "succes": "تم الحذف بنجاح",
      "echec": "فشلت عملية الحذف"
    },
    "m²": "m²",
    "sell - rent": "بيع/ إيجار",
    "non": "Non",
    "search": "أدخل العنوان أو المدينة في تونس",
    "contacts": "Coordonnées",
    "Coût": "Coût",
    "cost": "Coût",
    "name": "Nom",
    "describe_property": "Décrivez votre bien",
    "upload_images": "Ajoutez des photos",
    "locate_property": "Localisez votre bien",
    "localize_property": "Localisez votre bien",
    "select_city": "Sélectionnez une ville",
    "select_delegation": "Sélectionnez une délégation",
    "login": "Se connecter",
    "signup": "Créer un compte",
    "categories": {
      "apartment": "Appartement",
      "house": "Maison",
      "commercial": "Commercial",
      "land": "Terrain",
      "others": "Autres"
    },
    "appartement": "Appartement",
    "maison": "Maison",
    "terrain": "Terrain",
    "autres": "Autres",
    "sale": "Vente"
  }
};
